(function () {
    'use strict';

    var config = document.getElementById('wl-config');
    if (!config) return;
    config.id = 'wl-preorder-config';

    // Early hide for Hero on detail/share views to prevent flash

    var PROXY_BASE = config.getAttribute('data-proxy-base') || '';
    var CUSTOMER_ID = config.getAttribute('data-customer-id') || '';
    var IS_LOGGED_IN = config.getAttribute('data-customer-logged-in') === 'true';

    // The signed-in stash bar — avatar, editable name, description, Share/Edit
    // and the At a glance panel — is off at the merchant's request while the
    // stash profile is reviewed. Set to true to bring it back; nothing else
    // needs changing, and the profile it renders is still stored and returned.
    // The signed-out guest banner is unaffected and still shows.
    var SHOW_STASH_HEADER = false;
    var CUSTOMER_EMAIL = config.getAttribute('data-customer-email') || '';

    var HEART_SVG = '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

    var productCache = {};
    var wlConfig = {};
    var fbPixelInjected = false;

    function injectFbPixel(pixelId) {
        if (fbPixelInjected || !pixelId || typeof pixelId !== 'string') return;
        var trimmed = pixelId.trim();
        if (!trimmed) return;
        fbPixelInjected = true;
        try {
            (function (f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
                if (!f._fbq) f._fbq = n;
                n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
                t = b.createElement(e); t.async = !0; t.src = v;
                s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            window.fbq('init', trimmed);
            window.fbq('track', 'PageView');
        } catch (e) {}
    }

    function trackPixel(event, data) {
        try { if (window.fbq) window.fbq('track', event, data || {}); } catch (e) {}
    }

    function injectLaunchPoint(launchPoint) {
        if (launchPoint !== 'floating' && launchPoint !== 'menu') return;
        if (document.querySelector('.wl-launcher')) return;
        var a = document.createElement('a');
        a.href = '/pages/wishlist';
        a.className = 'wl-header-heart wl-launcher wl-launcher--' + launchPoint;
        a.setAttribute('aria-label', 'Wishlist');
        a.innerHTML = HEART_SVG + (launchPoint === 'menu' ? '<span class="wl-launcher-label">Wishlist</span>' : '');
        var badge = document.createElement('span');
        badge.className = 'wl-header-heart-badge';
        badge.setAttribute('aria-live', 'polite');
        badge.setAttribute('hidden', '');
        badge.textContent = '0';
        a.appendChild(badge);
        document.body.appendChild(a);
    }

    var sharedWishlist = null; // populated when ?share=<token> in URL
    var sharedLoading = false;

    var state = {
        wishlists: [],
        guestToken: null,
        loading: false,
        toastTimer: null,
    };

    try { state.guestToken = localStorage.getItem('wl_guest_token'); } catch (e) {}

    function escHtml(s) {
        var el = document.createElement('span');
        el.textContent = String(s);
        return el.innerHTML;
    }

    function getGuestToken() {
        if (!state.guestToken) {
            state.guestToken = 'wl_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
            try { localStorage.setItem('wl_guest_token', state.guestToken); } catch (e) {}
        }
        return state.guestToken;
    }

    function fetchApi(path, opts, retries) {
        retries = retries || 0;
        var url = PROXY_BASE + '/' + path;
        opts = opts || {};
        opts.headers = opts.headers || {};
        opts.headers['Content-Type'] = 'application/json';

        return fetch(url, opts)
            .then(function (r) {
                if (!r.ok) {
                    return r.text().then(function (t) {
                        console.error('[WL] API ' + r.status + ':', t);
                        var msg = 'API error: ' + r.status;
                        var code = null;
                        try {
                            var parsed = JSON.parse(t);
                            if (parsed && parsed.error) msg = parsed.error;
                            if (parsed && parsed.code) code = parsed.code;
                        } catch (e) { /* keep generic */ }
                        var err = new Error(msg);
                        err.status = r.status;
                        err.code = code;
                        throw err;
                    });
                }
                return r.json();
            })
            .catch(function (err) {
                if (retries < 2 && (err.name === 'AbortError' || err.message.indexOf('abort') > -1)) {
                    console.log('[WL] Retrying ' + path + ' (attempt ' + (retries + 2) + ')');
                    return new Promise(function (resolve) { setTimeout(resolve, 1000); })
                        .then(function () { return fetchApi(path, opts, retries + 1); });
                }
                throw err;
            });
    }

    function apiGet(path) {
        var token = IS_LOGGED_IN ? CUSTOMER_ID : getGuestToken();
        var param = IS_LOGGED_IN ? 'logged_in_customer_id' : 'guest_token';
        var sep = path.indexOf('?') > -1 ? '&' : '?';
        return fetchApi(path + sep + param + '=' + encodeURIComponent(token));
    }

    function apiPost(path, body) {
        var token = IS_LOGGED_IN ? CUSTOMER_ID : getGuestToken();
        var param = IS_LOGGED_IN ? 'logged_in_customer_id' : 'guest_token';
        var sep = path.indexOf('?') > -1 ? '&' : '?';

        if (IS_LOGGED_IN) {
            body.shopifyCustomerId = CUSTOMER_ID;
            if (CUSTOMER_EMAIL) body.customerEmail = CUSTOMER_EMAIL;
        } else {
            body.guestToken = getGuestToken();
        }

        return fetchApi(path + sep + param + '=' + encodeURIComponent(token), {
            method: 'POST',
            body: JSON.stringify(body),
        });
    }

    // ── Signup gate modal — shown when a guest hits the item or list limit ──
    // Built to the supplied design. Artwork is inline SVG rather than asset
    // files: three extra requests for a couple of KB costs more than the bytes
    // do, and inlining means the panel never renders half-dressed.
    //
    // The hero uses preserveAspectRatio="none" so the facets stretch to
    // whatever width the panel is instead of cropping at narrow sizes.
    var WL_GATE_HERO =
        '<svg viewBox="0 0 820 92" preserveAspectRatio="none" aria-hidden="true" focusable="false">' +
        '<rect width="820" height="92" fill="#f0dcdc"/>' +
        '<path d="M0 0h214c0 58-52 92-124 92H0z" fill="#a8121a"/>' +
        '<path d="M150 0h250L286 92H74z" fill="#f6e7e7"/>' +
        '<path d="M330 0h224L430 92H206z" fill="#e0b4b4"/>' +
        '<path d="M470 0h180L534 92H354z" fill="#f3dede"/>' +
        '<path d="M596 0h120L616 92H496z" fill="#d9a6a6"/>' +
        '<path d="M646 0h174v92H588z" fill="#343434"/>' +
        '<path d="M700 0h120v92H646z" fill="#3f3f3f"/>' +
        '<g stroke="#fff" stroke-width="1.6" opacity=".85">' +
        '<path d="M636 92L724 0"/><path d="M556 0l-70 92"/>' +
        '</g></svg>';

    // Line art at 1.6 stroke on a 34 box, matching the reference weight.
    var WL_GATE_ART = {
        heart:
            '<svg viewBox="0 0 34 34" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M17 28.2S4.6 20.6 4.6 12.7a6.6 6.6 0 0 1 12.4-3.2 6.6 6.6 0 0 1 12.4 3.2c0 7.9-12.4 15.5-12.4 15.5z"/>' +
            '</svg>',
        tag:
            '<svg viewBox="0 0 34 34" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M18.6 4.4h8.4a2 2 0 0 1 2 2v8.4a2 2 0 0 1-.6 1.4L17 27.6a2 2 0 0 1-2.8 0l-7.8-7.8a2 2 0 0 1 0-2.8L17.2 5a2 2 0 0 1 1.4-.6z"/>' +
            '<circle cx="23.4" cy="10" r="1.9"/>' +
            '<path d="M7.2 23.4v6.2m0 0-2.4-2.4m2.4 2.4 2.4-2.4"/>' +
            '</svg>',
        person:
            '<svg viewBox="0 0 34 34" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="17" cy="11.6" r="5.2"/>' +
            '<path d="M6.6 28.4a10.4 10.4 0 0 1 20.8 0"/>' +
            '</svg>',
        lists: WL_GATE_LISTS,
        box:
            '<svg viewBox="0 0 34 34" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M17 4.6l11.4 5v11.6L17 26.9 5.6 21.2V9.6z"/>' +
            '<path d="M5.6 9.6L17 15.3l11.4-5.7M17 15.3v11.6"/>' +
            '<path d="M27.4 24.6a3.4 3.4 0 0 0-6.8 0c0 2.6-1 3.4-1 3.4h8.8s-1-.8-1-3.4z" fill="#f5f4f3"/>' +
            '<path d="M23.3 30.1a1.3 1.3 0 0 0 1.4 0"/>' +
            '</svg>'
    };

    var WL_GATE_STASH =
        '<svg viewBox="0 0 2048 2048" aria-hidden="true">' +
        "<path transform=\"translate(0,0)\" fill=\"rgb(254,205,18)\" d=\"M 1070.05 273.003 C 1184.29 271.707 1301.89 272.522 1416.33 272.855 L 1526.53 272.807 C 1542.17 272.771 1565.29 271.89 1580.08 272.756 L 1579.97 588.03 C 1580.03 638.902 1578.62 700.244 1580.5 750.233 C 1614.42 751.207 1651.18 749.64 1683.98 750.991 L 1683.93 1230.01 C 1698.64 1230.27 1753.02 1229.55 1761.89 1232.53 C 1764.97 1236.14 1763.82 1305.4 1763.84 1315.66 L 1763.78 1477 L 1763.82 1637.54 C 1763.83 1666.88 1764.39 1697.93 1763.59 1727.02 C 1732.4 1728.03 1697.01 1727.38 1665.52 1727.48 L 1469.83 1727.75 L 920.706 1727.82 L 498.69 1727.72 L 361.694 1727.72 C 338.704 1727.74 308.416 1728.58 285.953 1727.41 L 286.12 1231.23 C 310.534 1228.8 340.394 1232.25 367.023 1229.97 L 367.139 751.052 C 395.874 748.228 439.261 751.637 470.974 749.939 L 471.386 449.366 L 471.478 328.371 C 471.533 311.454 470.805 289.189 471.551 272.884 C 533.761 270.458 597.966 274.549 660.353 272.764 C 671.79 272.436 685.527 272.231 696.948 272.842 L 697.013 501.328 L 1069.82 501.574 L 1070.05 273.003 z M 483.826 1464.65 C 514.405 1465.71 547.548 1464.98 578.528 1465.3 C 673.164 1466.18 767.807 1466.08 862.44 1464.99 C 863.888 1441.18 862.966 1410.55 862.954 1385.92 L 862.846 1229.92 C 854.891 1228.41 803.414 1228.91 792.252 1228.9 L 630.945 1228.89 L 533.053 1228.93 C 522.434 1228.93 492.843 1228.3 484.135 1229.64 C 481.933 1297.33 484.298 1366.11 483.536 1433.93 C 483.426 1443.75 483.183 1454.94 483.826 1464.65 z M 954.02 979.43 C 955.4 962.176 954.522 930.76 954.603 912.498 L 954.087 750.48 C 926.014 751.812 890.145 750.9 861.716 750.937 L 640.555 750.204 C 632.723 750.227 584.138 749.748 580.868 750.933 C 582.367 825.532 580.788 904.779 581.021 979.89 L 954.02 979.43 z\"/> <path transform=\"translate(0,0)\" fill=\"rgb(0,0,0)\" d=\"M 1683.93 1230.01 C 1698.64 1230.27 1753.02 1229.55 1761.89 1232.53 C 1764.97 1236.14 1763.82 1305.4 1763.84 1315.66 L 1763.78 1477 L 1763.82 1637.54 C 1763.83 1666.88 1764.39 1697.93 1763.59 1727.02 C 1732.4 1728.03 1697.01 1727.38 1665.52 1727.48 L 1469.83 1727.75 L 920.706 1727.82 L 498.69 1727.72 L 361.694 1727.72 C 338.704 1727.74 308.416 1728.58 285.953 1727.41 L 286.12 1231.23 C 310.534 1228.8 340.394 1232.25 367.023 1229.97 C 401.994 1230.04 449.784 1231.34 484.135 1229.64 C 481.933 1297.33 484.298 1366.11 483.536 1433.93 C 483.426 1443.75 483.183 1454.94 483.826 1464.65 C 514.405 1465.71 547.548 1464.98 578.528 1465.3 C 673.164 1466.18 767.807 1466.08 862.44 1464.99 C 863.888 1441.18 862.966 1410.55 862.954 1385.92 L 862.846 1229.92 L 1683.93 1230.01 z\"/> <path transform=\"translate(0,0)\" fill=\"rgb(230,38,48)\" d=\"M 1070.05 273.003 C 1184.29 271.707 1301.89 272.522 1416.33 272.855 L 1526.53 272.807 C 1542.17 272.771 1565.29 271.89 1580.08 272.756 L 1579.97 588.03 C 1580.03 638.902 1578.62 700.244 1580.5 750.233 L 1135.87 750.185 L 1011.55 750.123 C 1000.91 750.095 962.662 749.185 954.087 750.48 C 926.014 751.812 890.145 750.9 861.716 750.937 L 640.555 750.204 C 632.723 750.227 584.138 749.748 580.868 750.933 C 575.753 748.9 483.325 749.808 470.974 749.939 L 471.386 449.366 L 471.478 328.371 C 471.533 311.454 470.805 289.189 471.551 272.884 C 533.761 270.458 597.966 274.549 660.353 272.764 C 671.79 272.436 685.527 272.231 696.948 272.842 L 697.013 501.328 L 1069.82 501.574 L 1070.05 273.003 z\"/>" +
        '</svg>';

    var WL_GATE_LISTS =
        '<svg viewBox="0 0 34 34" fill="none" stroke="currentColor" stroke-width="1.6" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M13 10h14M13 17h14M13 24h14"/>' +
        '<circle cx="8" cy="10" r="1.3"/><circle cx="8" cy="17" r="1.3"/>' +
        '<circle cx="8" cy="24" r="1.3"/></svg>';

    var WL_GATE_CROSS =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
        'stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

    // Store-wide marketing wording rather than a per-merchant setting.
    // wlConfig.signupGateBenefits overrides it without a redeploy.
    var WL_GATE_BENEFITS_DEFAULT = [
        {
            art: 'heart',
            title: 'Never lose your wishlist',
            text: 'Your saved models stay with you on every device.'
        },
        {
            art: 'tag',
            title: 'Price drop alerts',
            text: 'Get an email when something on your wishlist drops in price.'
        },
        {
            art: 'box',
            title: 'Back in stock alerts',
            text: 'Know when a sold-out model becomes available again.'
        },
        {
            art: 'lists',
            title: 'Organise by project',
            text: 'Create separate lists for different builds, projects or gift ideas.'
        }
    ];

    var _signupGateEl = null;

    function buildGateBenefit(b) {
        var li = document.createElement('li');
        li.className = 'wl-gate-benefit';

        var art = document.createElement('div');
        art.className = 'wl-gate-benefit-icon';
        art.innerHTML = WL_GATE_ART[b.art] || WL_GATE_ART.heart;

        var copy = document.createElement('div');

        var t = document.createElement('p');
        t.className = 'wl-gate-benefit-title';
        t.textContent = b.title;

        var d = document.createElement('p');
        d.className = 'wl-gate-benefit-text';
        d.textContent = b.text;

        copy.appendChild(t);
        copy.appendChild(d);
        li.appendChild(art);
        li.appendChild(copy);
        return li;
    }

    function showSignupGate(code) {
        var titleText = 'Keep your wishlist';
        var bodyText = 'Create an account or sign in to keep your saved items and ' +
            'access them on any device.';
        if (code === 'GUEST_LIST_LIMIT') {
            titleText = 'Room for more lists';
            bodyText = 'Guests get one list. Create an account or sign in to keep it and ' +
                'split your models across as many lists as you want.';
        }

        if (_signupGateEl) {
            try { _signupGateEl.parentNode && _signupGateEl.parentNode.removeChild(_signupGateEl); } catch (e) {}
            _signupGateEl = null;
        }

        var overlay = document.createElement('div');
        overlay.className = 'wl-gate-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-labelledby', 'wl-gate-title');

        var panel = document.createElement('div');
        panel.className = 'wl-gate-panel';
        panel.addEventListener('click', function (e) { e.stopPropagation(); });

        var hero = document.createElement('div');
        hero.className = 'wl-gate-hero';
        hero.innerHTML = WL_GATE_HERO;

        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'wl-gate-close';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = WL_GATE_CROSS;
        closeBtn.addEventListener('click', closeGate);

        var body = document.createElement('div');
        body.className = 'wl-gate-body';

        var intro = document.createElement('div');
        intro.className = 'wl-gate-intro';

        var eyebrow = document.createElement('p');
        eyebrow.className = 'wl-gate-eyebrow';
        eyebrow.textContent = 'Wishlist';

        var title = document.createElement('h2');
        title.id = 'wl-gate-title';
        title.className = 'wl-gate-title';
        title.textContent = titleText;

        var sub = document.createElement('p');
        sub.className = 'wl-gate-sub';
        sub.textContent = bodyText;

        intro.appendChild(eyebrow);
        intro.appendChild(title);
        intro.appendChild(sub);

        // Multiple lists is the one genuinely account-only feature — guests get
        // exactly one — so it is promoted out of the benefits list into its own
        // tinted callout rather than sitting as a fourth equal row.
        var callout = document.createElement('div');
        callout.className = 'wl-gate-callout';

        var calloutArt = document.createElement('div');
        calloutArt.className = 'wl-gate-callout-icon';
        calloutArt.setAttribute('aria-hidden', 'true');
        calloutArt.innerHTML = WL_GATE_STASH;

        var calloutCopy = document.createElement('div');

        var calloutTitle = document.createElement('p');
        calloutTitle.className = 'wl-gate-callout-title';
        calloutTitle.textContent = 'Plan your builds';

        var calloutText = document.createElement('p');
        calloutText.className = 'wl-gate-callout-text';
        calloutText.textContent = 'Create multiple wishlists to plan, track and ' +
            'organise all your projects in one place.';

        calloutCopy.appendChild(calloutTitle);
        calloutCopy.appendChild(calloutText);
        callout.appendChild(calloutArt);
        callout.appendChild(calloutCopy);

        var benefits = document.createElement('ul');
        benefits.className = 'wl-gate-benefits';
        var list = (wlConfig && wlConfig.signupGateBenefits) || WL_GATE_BENEFITS_DEFAULT;
        for (var i = 0; i < list.length; i++) {
            benefits.appendChild(buildGateBenefit(list[i]));
        }

        var actions = document.createElement('div');
        actions.className = 'wl-gate-actions';

        // /account/login drops the customer on the account dashboard afterwards,
        // which is a dead end from here. /customer_authentication/login carries
        // a return_to, so they come back to the page they were on — and since
        // this modal fires when an add was blocked, that is the page where they
        // can finish what they started. return_to must be a relative URL.
        var returnTo = '/';
        try {
            returnTo = window.location.pathname + window.location.search;
        } catch (e) {}
        var authUrl = '/customer_authentication/login?return_to=' +
            encodeURIComponent(returnTo);

        // Under new customer accounts signing in and registering are one
        // passwordless flow, so both buttons lead to the same place.
        var create = document.createElement('a');
        create.href = authUrl;
        create.className = 'wl-gate-btn wl-gate-btn--solid';
        create.textContent = 'Create account';

        var signin = document.createElement('a');
        signin.href = authUrl;
        signin.className = 'wl-gate-btn wl-gate-btn--ghost';
        signin.textContent = 'Sign in';

        var later = document.createElement('button');
        later.type = 'button';
        later.className = 'wl-gate-later';
        later.textContent = 'Not now';
        later.addEventListener('click', closeGate);

        actions.appendChild(create);
        actions.appendChild(signin);
        actions.appendChild(later);

        body.appendChild(intro);
        body.appendChild(callout);
        body.appendChild(benefits);
        body.appendChild(actions);

        panel.appendChild(hero);
        panel.appendChild(closeBtn);
        panel.appendChild(body);
        overlay.appendChild(panel);
        overlay.addEventListener('click', closeGate);

        document.body.appendChild(overlay);
        _signupGateEl = overlay;
        try { create.focus(); } catch (e) {}

        function closeGate() {
            try { overlay.parentNode && overlay.parentNode.removeChild(overlay); } catch (e) {}
            _signupGateEl = null;
            document.removeEventListener('keydown', escHandler, true);
        }
        function escHandler(e) {
            if (e.key === 'Escape') { e.stopPropagation(); closeGate(); }
        }
        document.addEventListener('keydown', escHandler, true);
    }

    var _toastEl = null;
    var TOAST_PLACEMENTS = [
        'top-left', 'top-right', 'bottom-left', 'bottom-right',
        'top-center', 'bottom-center', 'left-center', 'right-center'
    ];

    function applyToastPlacement(el) {
        var placement = (wlConfig && wlConfig.popupPlacement) || 'bottom-left';
        if (TOAST_PLACEMENTS.indexOf(placement) === -1) placement = 'bottom-left';
        for (var i = 0; i < TOAST_PLACEMENTS.length; i++) {
            el.classList.remove('wl-toast--' + TOAST_PLACEMENTS[i]);
        }
        el.classList.add('wl-toast--' + placement);
    }

    function getToastEl() {
        if (!_toastEl) {
            _toastEl = document.createElement('div');
            _toastEl.className = 'wl-toast';
            _toastEl.setAttribute('role', 'status');
            _toastEl.setAttribute('aria-live', 'polite');
            _toastEl.innerHTML =
                '<div class="wl-toast-thumb"></div>' +
                '<div class="wl-toast-body"></div>' +
                '<button type="button" class="wl-toast-close" aria-label="Close">&times;</button>';
            document.body.appendChild(_toastEl);
            _toastEl.querySelector('.wl-toast-close').addEventListener('click', function () {
                _toastEl.classList.remove('is-visible');
            });
        }
        applyToastPlacement(_toastEl);
        return _toastEl;
    }

    // Backwards-compatible: showToast(msg) still works for plain text messages.
    // New: showToast(msg, { thumb, html, duration }) for rich toasts.
    function showToast(msg, opts) {
        opts = opts || {};
        var toast = getToastEl();
        var thumb = toast.querySelector('.wl-toast-thumb');
        var body = toast.querySelector('.wl-toast-body');

        if (opts.thumb) {
            thumb.innerHTML = '<img src="' + opts.thumb + '" alt="" />';
            thumb.classList.add('has-image');
        } else {
            thumb.innerHTML = '';
            thumb.classList.remove('has-image');
        }

        if (opts.html) {
            body.innerHTML = opts.html;
        } else {
            body.textContent = msg || '';
        }

        toast.classList.add('is-visible');
        if (state.toastTimer) clearTimeout(state.toastTimer);
        // Merchant-configured duration (seconds) wins over the per-call default.
        var cfgSeconds = wlConfig && Number(wlConfig.popupDuration);
        var duration = opts.duration
            || (cfgSeconds && cfgSeconds > 0 ? cfgSeconds * 1000 : 4000);
        state.toastTimer = setTimeout(function () {
            toast.classList.remove('is-visible');
        }, duration);
    }

    var _confirmResolve = null;

    function showConfirmDialog(opts) {
        opts = opts || {};
        return new Promise(function (resolve) {
            var overlay = document.getElementById('wl-confirm-overlay');
            var modal = document.getElementById('wl-confirm-modal');
            if (!overlay || !modal) {
                return resolve(window.confirm(opts.message || 'Are you sure?'));
            }
            modal.querySelector('.wl-confirm-modal-title').textContent = opts.title || 'Are you sure?';
            modal.querySelector('.wl-confirm-modal-message').textContent = opts.message || 'This action cannot be undone.';
            var goBtn = modal.querySelector('.wl-confirm-go');
            goBtn.textContent = opts.confirmLabel || 'Confirm';
            goBtn.classList.toggle('is-danger', !!opts.danger);
            overlay.removeAttribute('hidden');
            modal.removeAttribute('hidden');
            _confirmResolve = resolve;
        });
    }

    function closeConfirmDialog(result) {
        var overlay = document.getElementById('wl-confirm-overlay');
        var modal = document.getElementById('wl-confirm-modal');
        if (overlay) overlay.setAttribute('hidden', '');
        if (modal) modal.setAttribute('hidden', '');
        if (_confirmResolve) {
            _confirmResolve(!!result);
            _confirmResolve = null;
        }
    }

    function isWishlisted(productId) {
        var pid = String(productId);
        for (var i = 0; i < state.wishlists.length; i++) {
            var items = state.wishlists[i].items || [];
            for (var j = 0; j < items.length; j++) {
                if (String(items[j].shopifyProductId) === pid) return true;
            }
        }
        return false;
    }

    function isProductInList(wishlistId, productId) {
        var pid = String(productId);
        for (var i = 0; i < state.wishlists.length; i++) {
            if (state.wishlists[i].id !== wishlistId) continue;
            var items = state.wishlists[i].items || [];
            for (var j = 0; j < items.length; j++) {
                if (String(items[j].shopifyProductId) === pid) return true;
            }
        }
        return false;
    }

    function updateBadge() {
        var total = 0;
        var seen = {};
        for (var i = 0; i < state.wishlists.length; i++) {
            var items = state.wishlists[i].items || [];
            for (var j = 0; j < items.length; j++) {
                var pid = String(items[j].shopifyProductId);
                if (!seen[pid]) {
                    seen[pid] = true;
                    total++;
                }
            }
        }
        document.querySelectorAll('.wl-header-heart').forEach(function (link) {
            var badge = link.querySelector('.wl-header-heart-badge');
            if (badge) {
                // Real customers here already hold 100+ saved items, and the
                // badge is a 17px circle in someone else's header. Past 99 the
                // exact figure tells them nothing the page itself won't, so
                // cap it rather than let the pill grow across the icon.
                badge.textContent = total > 99 ? '99+' : String(total);
                if (total > 0) {
                    badge.removeAttribute('hidden');
                    link.classList.add('has-items');
                } else {
                    badge.setAttribute('hidden', '');
                    link.classList.remove('has-items');
                }
            }
        });
    }

    function enhanceHeaderHearts() {
        var links = document.querySelectorAll('a[href]');
        for (var i = 0; i < links.length; i++) {
            var link = links[i];
            var href = link.getAttribute('href') || '';

            // Match /pages/wishlist with optional query string. Handles absolute and relative URLs.
            if (!/\/pages\/wishlist(\?|#|\/?$)/.test(href)) continue;

            // Skip already-enhanced
            if (link.classList.contains('wl-header-heart')) continue;

            // Skip our own elements (overview cards, detail back link, blocks, etc.)
            if (link.closest('.wl-card-link, .wl-detail-back, [data-wl-groups], .wl-recommended, [data-wl-rec-list]')) continue;

            // Only enhance icon-style links (must contain an SVG). Skip text links / breadcrumbs.
            if (!link.querySelector('svg')) continue;

            link.classList.add('wl-header-heart');

            if (!link.querySelector('.wl-header-heart-badge')) {
                var badge = document.createElement('span');
                badge.className = 'wl-header-heart-badge';
                badge.setAttribute('aria-live', 'polite');
                badge.setAttribute('hidden', '');
                badge.textContent = '0';
                link.appendChild(badge);
            }
        }
    }

    function updateHeartButtons() {
        var type = (wlConfig && wlConfig.buttonType) || 'heart-noborder';
        var isText = type === 'text-bordered' || type === 'text-noborder';
        document.querySelectorAll('.wl-heart-btn').forEach(function (btn) {
            var pid = btn.getAttribute('data-product-id');
            var active = isWishlisted(pid);
            if (active) btn.classList.add('is-active');
            else btn.classList.remove('is-active');
            if (isText) {
                var labelEl = btn.querySelector('.wl-heart-btn-label');
                if (!labelEl) {
                    // Race fix: button was created before wlConfig had buttonType.
                    // Re-render its content now that we know the configured variant.
                    renderHeartBtnContent(btn, active);
                } else {
                    labelEl.textContent = active ? buttonLabelAfter() : buttonLabelBefore();
                }
            } else {
                // Variant flipped from text → heart: drop any stale label span
                var staleLabel = btn.querySelector('.wl-heart-btn-label');
                if (staleLabel) staleLabel.remove();
            }
        });
    }

    function buildThumbUrl(item) {
        if (!item || !item.productHandle) return '';
        return '/products/' + item.productHandle + '?v=1';
    }

    // "Updated today" carries more than a date stamp for something touched an
    // hour ago. Falls back to the date once it stops being useful.
    function formatRelativeDate(iso) {
        try {
            var then = new Date(iso);
            var startOfDay = function (d) {
                return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
            };
            var days = Math.round((startOfDay(new Date()) - startOfDay(then)) / 86400000);
            if (days <= 0) return 'Updated today';
            if (days === 1) return 'Updated yesterday';
            if (days < 7) return 'Updated ' + days + ' days ago';
            return 'Updated ' + formatDate(iso);
        } catch (e) { return ''; }
    }

    function formatDate(iso) {
        try {
            var d = new Date(iso);
            var dd = String(d.getDate()).padStart(2, '0');
            var mm = String(d.getMonth() + 1).padStart(2, '0');
            var yyyy = d.getFullYear();
            return dd + '/' + mm + '/' + yyyy;
        } catch (e) { return ''; }
    }

    function formatMoney(num) {
        if (window.Shopify && Shopify.formatMoney && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(Math.round(num * 100));
        }
        return '£' + num.toFixed(2);
    }

    function fetchProductInfo(handle, fresh) {
        if (!handle) return Promise.resolve(null);
        if (!fresh && productCache[handle]) return Promise.resolve(productCache[handle]);
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(async function (data) {
                if (!data) return null;
                var response = await fetch('/products/' + encodeURIComponent(handle) + '?section_id=wl-preorder-status', {
                    credentials: 'same-origin', cache: 'no-store'
                });
                if (!response.ok) return null;
                var statusDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
                var statusElement = statusDocument.querySelector('[data-wl-product-status]');
                if (!statusElement) return null;
                var status = JSON.parse(statusElement.textContent);
                if (status.themeId !== 167791427921 || String(status.productId) !== String(data.id) || typeof status.preorder !== 'boolean') return null;
                data.preorder = status.preorder;
                data.preorderText = String(status.preorderText || '');
                productCache[handle] = data;
                return data;
            })
            .catch(function () { return null; });
    }

    // Re-check at purchase time, including clicks before cards finish hydrating.
    async function prepareCartItems(entries, skipUnavailable) {
        var checked = await Promise.all(entries.map(async function (entry) {
            var info = await fetchProductInfo(entry.handle, true);
            if (!info) throw new Error('Could not check availability. Please open the product or try again.');
            var variant = (info.variants || []).filter(function (v) { return String(v.id) === String(entry.id); })[0];
            if (!variant || !variant.available) {
                if (skipUnavailable) return null;
                throw new Error('An item is out of stock. Please update your selection.');
            }
            var item = { id: entry.id, quantity: entry.quantity || 1 };
            if (info.preorder) {
                item.properties = { 'Availability': 'Pre-order' };
                if (info.preorderText) item.properties['Pre-order information'] = info.preorderText;
            }
            return { item: item, title: (info.title || entry.handle) + (info.preorderText ? ' (' + info.preorderText + ')' : ''), preorder: info.preorder };
        })).catch(function (error) { showToast(error.message); return null; });
        if (!checked) return null;
        checked = checked.filter(Boolean);
        if (!checked.length) { showToast('No items available to add to your basket.'); return null; }
        var preorders = checked.filter(function (entry) { return entry.preorder; });
        if (preorders.length && !await showConfirmDialog({
            title: 'Your basket includes pre-orders',
            message: preorders.map(function (entry) { return entry.title; }).join(', ') +
                ' — available to pre-order, not for immediate dispatch. Please check the product page for release information.',
            confirmLabel: 'Add to basket'
        })) return null;
        return checked.map(function (entry) { return entry.item; });
    }

    function hydrateDetailItems(root, wl) {
        var cards = root.querySelectorAll('[data-handle]');
        cards.forEach(function (card) {
            var handle = card.getAttribute('data-handle');
            if (!handle) return;
            fetchProductInfo(handle).then(function (info) {
                if (!info || !card.isConnected) return;

                var titleEl = card.querySelector('.wl-detail-item-title a, .wl-detail-item-title');
                if (titleEl && info.title) titleEl.textContent = info.title;

                var thumb = card.querySelector('.wl-detail-item-thumb');
                if (thumb && info.featured_image) {
                    thumb.style.backgroundImage = 'url(' + info.featured_image + ')';
                    thumb.style.backgroundSize = 'cover';
                    thumb.style.backgroundPosition = 'center';
                    thumb.classList.add('has-image');
                }

                var vendorSlot = card.querySelector('[data-vendor-slot]');
                if (vendorSlot) {
                    if (wlConfig.showVendor === true && info.vendor) {
                        vendorSlot.textContent = String(info.vendor);
                        vendorSlot.style.display = '';
                    } else {
                        vendorSlot.textContent = '';
                        vendorSlot.style.display = 'none';
                    }
                }

                var variantId = String(card.getAttribute('data-variant-id') || '');
                var unavailable = false;
                var v = null;
                if (variantId && info.variants) {
                    v = info.variants.filter(function (x) { return String(x.id) === variantId; })[0];
                    if (v) unavailable = !v.available;
                    else unavailable = !info.available;
                } else {
                    unavailable = !info.available;
                }

                // Variant selector — render only when wlConfig.chooseVariant is on
                // and the product has more than one variant.
                var variantSlot = card.querySelector('[data-variant-slot]');
                if (variantSlot && wlConfig && wlConfig.chooseVariant === true && info.variants && info.variants.length > 1) {
                    var options = info.variants.map(function (variant) {
                        var sel = String(variant.id) === variantId ? ' selected' : '';
                        var label = variant.title || (variant.option1 || '') + (variant.option2 ? ' / ' + variant.option2 : '') + (variant.option3 ? ' / ' + variant.option3 : '');
                        if (!variant.available) label += ' — sold out';
                        return '<option value="' + variant.id + '"' + sel + (!variant.available ? ' disabled' : '') + '>' + escHtml(label) + '</option>';
                    }).join('');
                    variantSlot.innerHTML = '<select class="wl-variant-select" data-wl-variant-select aria-label="Choose variant">' + options + '</select>';
                    variantSlot.removeAttribute('hidden');
                }
                var backorder = false;
                if (v && v.available && typeof v.inventory_quantity === 'number' && v.inventory_quantity <= 0) {
                    backorder = true;
                }
                if (unavailable && wlConfig.showOutOfStock === true) {
                    card.classList.add('is-unavailable');
                    var moveBtn = card.querySelector('.wl-detail-item-move');
                    if (moveBtn) {
                        moveBtn.textContent = langStr('outOfStockText', 'Out of stock');
                        var oosBg = wlConfig && wlConfig.lang && wlConfig.lang.outOfStockBg;
                        var oosColor = wlConfig && wlConfig.lang && wlConfig.lang.outOfStockColor;
                        if (oosBg) moveBtn.style.background = oosBg;
                        if (oosColor) moveBtn.style.color = oosColor;
                        moveBtn.disabled = true;
                        moveBtn.setAttribute('aria-disabled', 'true');
                    }
                }
                var slot = card.querySelector('[data-badge-slot]');
                if (slot) {
                    if (unavailable && wlConfig.showOutOfStock === true) {
                        slot.innerHTML = '<span class="wl-detail-item-badge wl-detail-item-badge--oos">Sold out</span>';
                    } else if (backorder) {
                        slot.innerHTML = '<span class="wl-detail-item-badge wl-detail-item-badge--backorder">Back-order</span>';
                    } else {
                        slot.innerHTML = '';
                    }
                }
            });
        });
    }

    function hydrateOverviewThumbs(root) {
        var tiles = root.querySelectorAll('.wl-card-thumb-tile[data-handle]:not(.wl-card-thumb-overflow)');
        tiles.forEach(function (tile) {
            var handle = tile.getAttribute('data-handle');
            if (!handle) return;
            fetchProductInfo(handle).then(function (info) {
                if (!info || !tile.isConnected) return;
                if (info.featured_image) {
                    tile.innerHTML = '<img src="' + escHtml(info.featured_image) + '" alt="' + escHtml(info.title || '') + '" loading="lazy" />';
                }
                // Carried on the tile so the hover preview needs no second
                // lookup, and so long-press on a phone still surfaces a name.
                if (info.title) {
                    tile.setAttribute('data-wl-title', info.title);
                    tile.setAttribute('title', info.title);
                }
            });
        });
    }

    // Hover preview for the thumbnail strips. The strips scroll horizontally on
    // small screens, so the preview is appended to the body rather than the
    // tile — inside an overflow container it would simply be clipped.
    var _thumbPreview = null;

    function hideThumbPreview() {
        if (!_thumbPreview) return;
        try { _thumbPreview.parentNode.removeChild(_thumbPreview); } catch (e) {}
        _thumbPreview = null;
    }

    function showThumbPreview(tile) {
        var img = tile.querySelector('img');
        var title = tile.getAttribute('data-wl-title');
        if (!img || !title) return;

        hideThumbPreview();

        var el = document.createElement('div');
        el.className = 'wl-thumb-preview';
        el.innerHTML =
            '<img src="' + escHtml(img.getAttribute('src') || '') + '" alt="" />' +
            '<p>' + escHtml(title) + '</p>';
        document.body.appendChild(el);
        _thumbPreview = el;

        var r = tile.getBoundingClientRect();
        var w = el.offsetWidth;
        var h = el.offsetHeight;

        // Prefer above the tile; drop below when there is no room, and keep it
        // inside the viewport horizontally.
        var top = r.top + window.scrollY - h - 10;
        if (r.top < h + 16) top = r.bottom + window.scrollY + 10;

        var left = r.left + window.scrollX + (r.width / 2) - (w / 2);
        left = Math.max(window.scrollX + 8, Math.min(left, window.scrollX + document.documentElement.clientWidth - w - 8));

        el.style.top = top + 'px';
        el.style.left = left + 'px';
    }

    // Pointer-based rather than a CSS :hover rule so it can be limited to real
    // hover devices; on touch the tap navigates instead.
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        document.addEventListener('mouseover', function (e) {
            var tile = e.target.closest && e.target.closest('.wl-ov-thumb[data-wl-title]');
            if (tile) showThumbPreview(tile);
        });
        document.addEventListener('mouseout', function (e) {
            var tile = e.target.closest && e.target.closest('.wl-ov-thumb');
            if (tile) hideThumbPreview();
        });
        window.addEventListener('scroll', hideThumbPreview, { passive: true });
    }

    function renderItemsGrid(wl) {
        var items = wl.items || [];
        if (!items.length) {
            return '<p class="wl-detail-empty">This list is empty.</p>';
        }
        var bulkEnabled = wlConfig && wlConfig.bulkActions === true;
        var qtyEnabled = wlConfig && wlConfig.manageQuantity === true;
        var variantEnabled = wlConfig && wlConfig.chooseVariant === true;

        var html = '';
        if (bulkEnabled) {
            var lblSelectAll = escHtml(langStr('bulkSelectAll', 'Select all'));
            var lblBulkMove = escHtml(langStr('bulkMoveToCart', 'Move to basket'));
            var lblBulkDelete = escHtml(langStr('bulkDelete', 'Delete'));
            html +=
                '<div class="wl-bulk-toolbar" data-wl-bulk-toolbar data-wishlist-id="' + escHtml(wl.id) + '">' +
                '  <label class="wl-bulk-select-all">' +
                '    <input type="checkbox" data-wl-bulk-select-all aria-label="' + lblSelectAll + '" />' +
                '    <span>' + lblSelectAll + '</span>' +
                '  </label>' +
                '  <span class="wl-bulk-selected-label" data-wl-bulk-selected-label>0 selected</span>' +
                '  <div class="wl-bulk-actions">' +
                '    <button type="button" class="wl-bulk-add" data-wl-bulk-add-selected data-wishlist-id="' + escHtml(wl.id) + '" disabled>' + lblBulkMove + '</button>' +
                '    <button type="button" class="wl-bulk-remove" data-wl-bulk-remove-selected data-wishlist-id="' + escHtml(wl.id) + '" disabled>' + lblBulkDelete + '</button>' +
                '  </div>' +
                '</div>';
        }

        var viewMode = (wlConfig && wlConfig.wishlistView) || 'list';
        if (viewMode !== 'list' && viewMode !== 'grid' && viewMode !== 'compact') viewMode = 'list';
        html += '<div class="wl-detail-grid wl-detail-grid--' + viewMode + (bulkEnabled ? ' wl-detail-grid--bulk' : '') + '">';
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            html +=
                '<article class="wl-detail-item" data-product-id="' + escHtml(it.shopifyProductId) + '" data-variant-id="' + escHtml(it.shopifyVariantId || '') + '" data-handle="' + escHtml(it.productHandle || '') + '" data-qty="1">' +
                (bulkEnabled
                    ? '  <label class="wl-detail-item-select" aria-label="Select item"><input type="checkbox" data-wl-item-checkbox /></label>'
                    : '') +
                '  <div class="wl-detail-item-badge-slot" data-badge-slot></div>' +
                '  <button type="button" class="wl-detail-item-remove" data-wl-remove-item data-wishlist-id="' + escHtml(wl.id) + '" data-product-id="' + escHtml(it.shopifyProductId) + '" aria-label="Remove">&times;</button>' +
                '  <div class="wl-detail-item-thumb"></div>' +
                '  <div class="wl-detail-item-body">' +
                '    <p class="wl-detail-item-title"><a href="/products/' + escHtml(it.productHandle || '') + '">' + escHtml(it.productHandle || 'Product') + '</a></p>' +
                '    <p class="wl-detail-item-vendor" data-vendor-slot></p>' +
                '    <p class="wl-detail-item-price">' + formatMoney(parseFloat(it.priceAtAdd || 0)) + '</p>' +
                (variantEnabled ? '    <div class="wl-detail-item-variant" data-variant-slot hidden></div>' : '') +
                (qtyEnabled
                    ? '    <div class="wl-detail-item-qty" data-qty-slot>' +
                      '      <button type="button" class="wl-qty-btn" data-wl-qty-dec aria-label="Decrease quantity">&minus;</button>' +
                      '      <input type="text" class="wl-qty-input" data-wl-qty-input value="1" readonly aria-label="Quantity" />' +
                      '      <button type="button" class="wl-qty-btn" data-wl-qty-inc aria-label="Increase quantity">+</button>' +
                      '    </div>'
                    : '') +
                '  </div>' +
                (wlConfig.showMoveToCart !== false ? '  <button type="button" class="wl-detail-item-move" data-wl-move-to-cart data-wishlist-id="' + escHtml(wl.id) + '" data-product-id="' + escHtml(it.shopifyProductId) + '" data-variant-id="' + escHtml(it.shopifyVariantId || '') + '" data-handle="' + escHtml(it.productHandle || '') + '"' + moveBtnStyle() + '>' + escHtml(langStr('moveToCartText', 'Move to basket')) + '</button>' : '') +
                '</article>';
        }
        html += '</div>';
        return html;
    }

    // ── Stash profile ─────────────────────────────────────────────────────
    // Name, blurb and avatar, stored on the customer's Shopify metafield. The
    // avatar is a product they have already wishlisted, so it needs no file
    // storage and is something they picked rather than uploaded.
    var stashProfile = { name: null, description: null, avatarHandle: null };

    var WL_STASH_MAX_NAME = 40;
    var WL_STASH_MAX_DESC = 150;

    var WL_STASH_ICONS = {
        pencil:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
        share:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/>' +
            '<circle cx="18" cy="19" r="2.6"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>',
        camera:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M3 8.4h3.4l1.5-2.2h8.2l1.5 2.2H21v10.2H3z"/><circle cx="12" cy="13.2" r="3.3"/></svg>'
    };

    function stashDisplayName() {
        return stashProfile.name || 'Your wishlist';
    }

    function stashTotals() {
        var lists = state.wishlists || [];
        var items = 0;
        for (var i = 0; i < lists.length; i++) items += (lists[i].items || []).length;
        return { lists: lists.length, items: items };
    }

    // Every distinct handle across their lists — the pool the avatar is chosen
    // from, so the picture is always something they saved.
    function stashAvatarChoices() {
        var out = [];
        var lists = state.wishlists || [];
        for (var i = 0; i < lists.length; i++) {
            var items = lists[i].items || [];
            for (var j = 0; j < items.length; j++) {
                var h = items[j].productHandle;
                if (h && out.indexOf(h) === -1) out.push(h);
            }
        }
        return out;
    }

    // A guest's list lives in a cookie on one device. Saying so plainly is
    // both the honest thing and the strongest argument for an account —
    // stronger than listing features, because it is about losing what they
    // have already built.
    var WL_GUEST_ICONS = {
        device:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<rect x="6.5" y="2.5" width="11" height="19" rx="2.2"/><path d="M10.6 18.6h2.8"/></svg>',
        vanish:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M20 12a8 8 0 1 1-2.6-5.9"/><path d="M20 3.4V8h-4.6"/></svg>',
        name:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M13.4 3.4h6.2a1 1 0 0 1 1 1v6.2a1 1 0 0 1-.3.7l-9 9a1 1 0 0 1-1.4 0l-6.2-6.2a1 1 0 0 1 0-1.4l9-9a1 1 0 0 1 .7-.3z"/>' +
            '<circle cx="16.8" cy="7.2" r="1.4"/></svg>',
        avatar:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="10" r="3"/>' +
            '<path d="M5.9 19a6.6 6.6 0 0 1 12.2 0"/></svg>',
        bookmark:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M6 3.6h12a1 1 0 0 1 1 1v16.2l-7-4.4-7 4.4V4.6a1 1 0 0 1 1-1z"/></svg>'
    };

    var WL_GUEST_REASONS = [
        ['device', 'Saved on this device only', 'Your items are stored in this browser or phone.'],
        ['vanish', 'Could disappear', 'Clearing cookies or switching device may remove them.'],
        ['name', 'Organise by project', 'Create separate lists for builds, projects or gift ideas.'],
        ['bookmark', 'Alerts on your items', 'We will email you when prices drop or stock comes back.']
    ];

    function renderGuestBanner() {
        var back = '/';
        try { back = window.location.pathname + window.location.search; } catch (e) {}
        var authUrl = '/customer_authentication/login?return_to=' + encodeURIComponent(back);

        var totals = stashTotals();
        var lead = totals.items > 0
            ? 'The ' + totals.items + (totals.items === 1 ? ' item' : ' items') +
              ' you have saved live on this device only. Clear your cookies or ' +
              'switch device and they could disappear.'
            : 'Anything you save as a guest lives on this device only, and you ' +
              'can keep three items at most.';

        var cards = '';
        for (var i = 0; i < WL_GUEST_REASONS.length; i++) {
            var r = WL_GUEST_REASONS[i];
            cards +=
                '<li class="wl-guest-card">' +
                '  <span class="wl-guest-card-art" aria-hidden="true">' + WL_GUEST_ICONS[r[0]] + '</span>' +
                '  <span class="wl-guest-card-copy">' +
                '    <span class="wl-guest-card-title">' + escHtml(r[1]) + '</span>' +
                '    <span class="wl-guest-card-text">' + escHtml(r[2]) + '</span>' +
                '  </span>' +
                '</li>';
        }

        return '' +
        '<section class="wl-guest">' +
        (totals.items > 0
            ? '  <span class="wl-guest-pill">' + WL_GUEST_ICONS.bookmark + totals.items +
              (totals.items === 1 ? ' item saved' : ' items saved') + '</span>'
            : '') +
        '  <div class="wl-guest-copy">' +
        '    <p class="wl-guest-eyebrow">Browsing as a guest</p>' +
        '    <h2 class="wl-guest-title">Your wishlist is not saved yet</h2>' +
        '    <p class="wl-guest-lead">' + escHtml(lead) + '</p>' +
        '    <div class="wl-guest-actions">' +
        '      <a class="wl-guest-btn wl-guest-btn--solid" href="' + authUrl + '">Create account</a>' +
        '      <a class="wl-guest-btn wl-guest-btn--ghost" href="' + authUrl + '">Sign in</a>' +
        '    </div>' +
        '  </div>' +
        '  <div class="wl-guest-why">' +
        '    <p class="wl-guest-why-title">Why save your wishlist?</p>' +
        '    <ul class="wl-guest-cards">' + cards + '</ul>' +
        '  </div>' +
        '</section>';
    }

    function renderStashHeader() {
        if (!IS_LOGGED_IN) return renderGuestBanner();
        var t = stashTotals();
        var camera =
            '<button type="button" class="wl-stash-cam" data-wl-stash-edit aria-label="Change your picture">' +
            WL_STASH_ICONS.camera + '</button>';

        var avatar;
        if (stashProfile.avatarUrl) {
            avatar = '<span class="wl-stash-avatar"><img src="' + escHtml(stashProfile.avatarUrl) +
                '" alt="" /></span>';
        } else if (stashProfile.avatarHandle) {
            avatar = '<span class="wl-stash-avatar wl-card-thumb-tile" data-handle="' +
                escHtml(stashProfile.avatarHandle) + '"></span>';
        } else {
            avatar = '<span class="wl-stash-avatar wl-stash-avatar--empty" aria-hidden="true">' +
                WL_GATE_STASH + '</span>';
        }

        var value = 0;
        (state.wishlists || []).forEach(function (w) {
            (w.items || []).forEach(function (it) { value += parseFloat(it.priceAtAdd || 0); });
        });

        // Deliberately not "items on sale": nearly every product carries an RRP
        // above its price on this catalogue, so that number would read as most
        // of the stash and mean nothing. Value is real and needs no lookups.
        var glance =
            '<aside class="wl-stash-glance">' +
            '  <p class="wl-stash-glance-title">At a glance</p>' +
            '  <div class="wl-stash-glance-row">' +
            '    <div class="wl-stash-stat">' +
            '      <span class="wl-stash-stat-art" aria-hidden="true">' + WL_OV_ICONS.bookmark + '</span>' +
            '      <span class="wl-stash-stat-n">' + t.items + '</span>' +
            '      <span class="wl-stash-stat-l">Saved item' + (t.items === 1 ? '' : 's') + '</span>' +
            '    </div>' +
            '    <div class="wl-stash-stat">' +
            '      <span class="wl-stash-stat-art" aria-hidden="true">' + WL_LM_ICONS.lists + '</span>' +
            '      <span class="wl-stash-stat-n">' + t.lists + '</span>' +
            '      <span class="wl-stash-stat-l">List' + (t.lists === 1 ? '' : 's') + '</span>' +
            '    </div>' +
            '    <div class="wl-stash-stat">' +
            '      <span class="wl-stash-stat-art" aria-hidden="true">' + (WL_GATE_ART.heart || '') + '</span>' +
            '      <span class="wl-stash-stat-n">' + formatMoney(value) + '</span>' +
            '      <span class="wl-stash-stat-l">Stash value</span>' +
            '    </div>' +
            '  </div>' +
            '</aside>';

        return '' +
        '<section class="wl-stash">' +
        '  <span class="wl-stash-avatar-wrap">' + avatar + camera + '</span>' +
        '  <div class="wl-stash-body">' +
        '    <h2 class="wl-stash-name">' + escHtml(stashDisplayName()) +
        '      <button type="button" class="wl-stash-edit" data-wl-stash-edit aria-label="Edit your stash">' +
        WL_STASH_ICONS.pencil + '</button>' +
        '    </h2>' +
        '    <p class="wl-stash-counts">' + t.lists + (t.lists === 1 ? ' list' : ' lists') +
        '      <span aria-hidden="true">&middot;</span> ' + t.items +
        (t.items === 1 ? ' saved item' : ' saved items') + '</p>' +
        (stashProfile.description
            ? '    <p class="wl-stash-desc">' + escHtml(stashProfile.description) + '</p>'
            : '') +
        '    <div class="wl-stash-actions">' +
        (wlConfig.shareWishlist !== false
            ? '      <button type="button" class="wl-stash-btn" data-wl-stash-share>' +
              WL_STASH_ICONS.share + 'Share wishlist</button>'
            : '') +
        '      <button type="button" class="wl-stash-btn" data-wl-stash-edit>' +
        WL_STASH_ICONS.pencil + 'Edit wishlist</button>' +
        '    </div>' +
        '  </div>' +
        glance +
        '</section>';
    }

    var _stashModal = null;

    function closeStashModal() {
        if (!_stashModal) return;
        try { _stashModal.parentNode.removeChild(_stashModal); } catch (e) {}
        _stashModal = null;
    }

    function openStashModal() {
        closeStashModal();

        var choices = stashAvatarChoices();
        var tiles = '';
        for (var i = 0; i < choices.length; i++) {
            tiles +=
                '<button type="button" class="wl-stash-pick wl-card-thumb-tile' +
                (choices[i] === stashProfile.avatarHandle ? ' is-selected' : '') +
                '" data-wl-stash-pick="' + escHtml(choices[i]) + '" data-handle="' +
                escHtml(choices[i]) + '" aria-label="Use this item as your picture"></button>';
        }

        var overlay = document.createElement('div');
        overlay.className = 'wl-stash-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-labelledby', 'wl-stash-modal-title');
        overlay.innerHTML =
            '<div class="wl-stash-modal">' +
            '  <div class="wl-stash-modal-head">' +
            '    <h2 id="wl-stash-modal-title" class="wl-stash-modal-title">Edit your stash</h2>' +
            '    <button type="button" class="wl-stash-close" data-wl-stash-close aria-label="Close">&times;</button>' +
            '  </div>' +
            '  <div class="wl-stash-modal-body">' +
            '    <label class="wl-stash-label" for="wl-stash-name">Stash name</label>' +
            '    <input type="text" id="wl-stash-name" class="wl-stash-input" maxlength="' + WL_STASH_MAX_NAME +
            '" value="' + escHtml(stashProfile.name || '') + '" placeholder="e.g. Ben&rsquo;s Wishlist" />' +
            '    <p class="wl-stash-count" data-wl-count-for="wl-stash-name">' +
            (stashProfile.name || '').length + '/' + WL_STASH_MAX_NAME + '</p>' +
            '    <label class="wl-stash-label" for="wl-stash-desc">About your stash <span>(optional)</span></label>' +
            '    <textarea id="wl-stash-desc" class="wl-stash-textarea" rows="3" maxlength="' + WL_STASH_MAX_DESC +
            '" placeholder="What are you building?">' + escHtml(stashProfile.description || '') + '</textarea>' +
            '    <p class="wl-stash-count" data-wl-count-for="wl-stash-desc">' +
            (stashProfile.description || '').length + '/' + WL_STASH_MAX_DESC + '</p>' +
            '    <p class="wl-stash-label">Picture</p>' +
            '    <div class="wl-stash-upload">' +
            '      <label class="wl-stash-upload-btn">' + WL_STASH_ICONS.camera +
            '        <span>Upload a picture</span>' +
            '        <input type="file" accept="image/jpeg,image/png,image/webp" ' +
            '               data-wl-stash-file hidden />' +
            '      </label>' +
            '      <span class="wl-stash-upload-note">JPG, PNG or WebP, up to 4MB.</span>' +
            '    </div>' +
            '    <p class="wl-stash-upload-status" data-wl-stash-status hidden></p>' +
            (choices.length
                ? '    <p class="wl-stash-hint">Pick something you have saved.</p>' +
                  '    <div class="wl-stash-picks">' + tiles + '</div>' +
                  '    <button type="button" class="wl-stash-clear" data-wl-stash-pick="">Remove current picture</button>'
                : '    <p class="wl-stash-hint">Save an item first and you can use its picture here.</p>') +
            '  </div>' +
            '  <div class="wl-stash-modal-foot">' +
            '    <button type="button" class="wl-stash-cancel" data-wl-stash-close>Cancel</button>' +
            '    <button type="button" class="wl-stash-save" data-wl-stash-save>Save</button>' +
            '  </div>' +
            '</div>';

        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) closeStashModal();
        });

        document.body.appendChild(overlay);
        _stashModal = overlay;
        hydrateOverviewThumbs(overlay);

        var nameInput = overlay.querySelector('#wl-stash-name');
        if (nameInput) nameInput.focus();
    }

    function saveStashProfile() {
        if (!_stashModal) return;
        var nameEl = _stashModal.querySelector('#wl-stash-name');
        var descEl = _stashModal.querySelector('#wl-stash-desc');
        var picked = _stashModal.querySelector('.wl-stash-pick.is-selected');

        var next = {
            name: nameEl ? nameEl.value : '',
            description: descEl ? descEl.value : '',
            avatarHandle: picked ? picked.getAttribute('data-wl-stash-pick') : '',
            // A chosen product image supersedes an upload; only one can show,
            // so only one is stored.
            avatarUrl: picked ? '' : (stashProfile.avatarUrl || '')
        };

        var saveBtn = _stashModal.querySelector('[data-wl-stash-save]');
        if (saveBtn) { saveBtn.disabled = true; saveBtn.textContent = 'Saving…'; }

        apiPost('api/stash-profile', {
            shopifyCustomerId: CUSTOMER_ID,
            name: next.name,
            description: next.description,
            avatarHandle: next.avatarHandle,
            avatarUrl: next.avatarUrl
        })
            .then(function (res) {
                // Trust the server's copy: it trims to the limits and drops an
                // avatar that is not actually on one of their lists.
                stashProfile = (res && res.stashProfile) || stashProfile;
                closeStashModal();
                renderGroupsBlocks();
            })
            .catch(function () {
                if (saveBtn) { saveBtn.disabled = false; saveBtn.textContent = 'Save'; }
                showToast('Could not save your changes. Please try again.');
            });
    }

    document.addEventListener('click', function (e) {
        if (!e.target.closest) return;

        if (e.target.closest('[data-wl-stash-edit]')) {
            e.preventDefault();
            openStashModal();
            return;
        }
        if (e.target.closest('[data-wl-stash-close]')) {
            e.preventDefault();
            closeStashModal();
            return;
        }
        if (e.target.closest('[data-wl-stash-save]')) {
            e.preventDefault();
            saveStashProfile();
            return;
        }

        var pick = e.target.closest('[data-wl-stash-pick]');
        if (pick && _stashModal) {
            e.preventDefault();
            var all = _stashModal.querySelectorAll('.wl-stash-pick');
            for (var i = 0; i < all.length; i++) all[i].classList.remove('is-selected');
            if (pick.classList.contains('wl-stash-pick')) pick.classList.add('is-selected');
            return;
        }

        if (e.target.closest('[data-wl-stash-share]')) {
            e.preventDefault();
            // Sharing the stash means sharing its lists; the per-list share is
            // the only link that exists, so send them to the list they own.
            showToast('Open a list and choose Share to send it to someone.');
        }
    });

    document.addEventListener('change', function (e) {
        var input = e.target.closest && e.target.closest('[data-wl-stash-file]');
        if (!input || !input.files || !input.files[0]) return;

        var file = input.files[0];
        var status = _stashModal && _stashModal.querySelector('[data-wl-stash-status]');
        var show = function (msg) {
            if (!status) return;
            status.textContent = msg;
            status.hidden = false;
        };

        // Checked here as well as on the server so an obvious mistake costs a
        // message rather than a round trip with the bytes attached.
        if (file.size > 4 * 1024 * 1024) {
            show('That image is too large — 4MB is the limit.');
            input.value = '';
            return;
        }

        show('Uploading…');

        var fd = new FormData();
        fd.append('shopifyCustomerId', CUSTOMER_ID);
        fd.append('file', file);

        // Sent as multipart, so it bypasses apiPost's JSON body entirely.
        var token = IS_LOGGED_IN ? CUSTOMER_ID : getGuestToken();
        var param = IS_LOGGED_IN ? 'logged_in_customer_id' : 'guest_token';
        fetch(PROXY_BASE + '/api/stash-avatar?' + param + '=' + encodeURIComponent(token), {
            method: 'POST',
            body: fd
        })
            .then(function (r) { return r.json(); })
            .then(function (res) {
                if (!res || res.error) {
                    show(res && res.error ? res.error : 'Could not upload that image.');
                    return;
                }
                stashProfile = res.stashProfile || stashProfile;
                show('Picture updated.');
                var picks = _stashModal ? _stashModal.querySelectorAll('.wl-stash-pick') : [];
                for (var i = 0; i < picks.length; i++) picks[i].classList.remove('is-selected');
            })
            .catch(function () { show('Could not upload that image.'); });
    });

    document.addEventListener('input', function (e) {
        var el = e.target;
        if (!el || !el.id || !_stashModal) return;
        var counter = _stashModal.querySelector('[data-wl-count-for="' + el.id + '"]');
        if (!counter) return;
        var max = el.id === 'wl-stash-name' ? WL_STASH_MAX_NAME : WL_STASH_MAX_DESC;
        counter.textContent = el.value.length + '/' + max;
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _stashModal) closeStashModal();
    });

    // ── Learn more ────────────────────────────────────────────────────────
    // Four topics, each expanding in place. Sub-pages would mean four more
    // Shopify pages for the merchant to create and keep in step; an accordion
    // keeps the whole thing in one block and one deploy.
    var WL_LM_ICONS = {
        lists:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M6 3.6h12a1 1 0 0 1 1 1v16.2l-7-4.4-7 4.4V4.6a1 1 0 0 1 1-1z"/></svg>',
        bell:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 21.4a1.9 1.9 0 0 0 1.9-1.9h-3.8A1.9 1.9 0 0 0 12 21.4z"/>' +
            '<path d="M18 15.6v-4.8a6 6 0 0 0-4.6-5.8v-.6a1.4 1.4 0 0 0-2.8 0v.6A6 6 0 0 0 6 10.8v4.8l-1.7 1.7v.8h15.4v-.8z"/></svg>',
        share:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/>' +
            '<circle cx="18" cy="19" r="2.6"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>',
        faq:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="9"/>' +
            '<path d="M9.6 9.4a2.5 2.5 0 1 1 3.3 2.4c-.6.2-.9.8-.9 1.4v.4"/>' +
            '<path d="M12 17.1h.01"/></svg>',
        mail:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="M3.6 6.6L12 13l8.4-6.4"/></svg>'
    };

    var WL_LM_TOPICS = [
        {
            art: 'lists',
            title: 'Managing your lists',
            text: 'Create, edit and organise multiple wishlists to keep your projects separate and easy to track.',
            body: [
                ['Creating a list', 'Use Create new list on your wishlist page, or add an item and choose Create new list from the heart menu.'],
                ['Renaming or deleting', 'Open the list and use Edit list or Delete. Deleting a list removes the list, not the products.'],
                ['Moving an item', 'Open a list and choose Move to another list on any item.'],
                ['How many lists', 'Signed in, as many as you like. As a guest you get one, and it is kept when you create an account.']
            ]
        },
        {
            art: 'bell',
            title: 'Alerts & notifications',
            text: 'Get notified when prices drop or items come back in stock.',
            body: [
                ['Price drop alerts', 'If something you have saved goes down in price, we email you.'],
                ['Back in stock alerts', 'If a sold-out item returns, we email you.'],
                ['Turning them off', 'Open a list and use the alert buttons at the top to switch either kind off for that list.'],
                ['Unsubscribing entirely', 'Every email carries an unsubscribe link, which stops all marketing email from us.']
            ]
        },
        {
            art: 'share',
            title: 'Share your lists',
            text: 'Share your wishlists with friends and family for gift ideas or project collaboration.',
            body: [
                ['Sharing a list', 'Open the list and choose Share. You get a link that anyone can open.'],
                ['What people see', 'They see the items and prices. They cannot add, remove or change anything.'],
                ['Stopping sharing', 'Delete the list, or ask us to revoke the link.']
            ]
        },
        {
            art: 'faq',
            title: 'FAQs',
            text: 'Answers to the most common questions about wishlists.',
            body: [
                ['Do I need an account?', 'You can save up to three items as a guest. An account keeps them for good and unlocks multiple lists and alerts.'],
                ['Will my guest list be kept?', 'Yes. Sign in or create an account and anything you saved as a guest moves across.'],
                ['Does saving reserve stock?', 'No. A wishlist does not hold or reserve anything.'],
                ['Do prices update?', 'Yes, the list shows the current price, and marks anything that has dropped since you saved it.']
            ]
        }
    ];

    function renderLearnMore(root) {
        var topUrl = root.getAttribute('data-top-url') || '';
        var alertsUrl = root.getAttribute('data-alerts-url') || '';

        var cards = '';
        for (var i = 0; i < WL_LM_TOPICS.length; i++) {
            var t = WL_LM_TOPICS[i];
            var rows = '';
            for (var b = 0; b < t.body.length; b++) {
                rows +=
                    '<div class="wl-lm-qa">' +
                    '  <p class="wl-lm-q">' + escHtml(t.body[b][0]) + '</p>' +
                    '  <p class="wl-lm-a">' + escHtml(t.body[b][1]) + '</p>' +
                    '</div>';
            }
            cards +=
                '<div class="wl-lm-card">' +
                '  <button type="button" class="wl-lm-card-head" data-wl-lm-toggle="' + i + '" aria-expanded="false">' +
                '    <span class="wl-lm-card-art" aria-hidden="true">' + WL_LM_ICONS[t.art] + '</span>' +
                '    <span class="wl-lm-card-copy">' +
                '      <span class="wl-lm-card-title">' + escHtml(t.title) + '</span>' +
                '      <span class="wl-lm-card-text">' + escHtml(t.text) + '</span>' +
                '    </span>' +
                '    <span class="wl-lm-card-chevron" aria-hidden="true">' +
                '      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
                'stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' +
                '    </span>' +
                '  </button>' +
                '  <div class="wl-lm-card-body" hidden>' + rows + '</div>' +
                '</div>';
        }

        var panels = '';
        if (topUrl) {
            panels +=
                '<a class="wl-lm-panel wl-lm-panel--picks" href="' + escHtml(topUrl) + '">' +
                '  <span class="wl-lm-eyebrow">Community picks</span>' +
                '  <span class="wl-lm-panel-title">Top 10 most wishlisted items</span>' +
                '  <span class="wl-lm-panel-text">See what other modellers are adding to their wishlists right now.</span>' +
                '  <span class="wl-lm-panel-link">View all popular items <span aria-hidden="true">&rarr;</span></span>' +
                '</a>';
        }
        if (alertsUrl) {
            panels +=
                '<a class="wl-lm-panel" href="' + escHtml(alertsUrl) + '">' +
                '  <span class="wl-lm-panel-art" aria-hidden="true">' + WL_LM_ICONS.mail + '</span>' +
                '  <span class="wl-lm-panel-title">Never miss a deal</span>' +
                '  <span class="wl-lm-panel-text">Get email alerts for price drops and back in stock items.</span>' +
                '  <span class="wl-lm-panel-link">Manage alerts <span aria-hidden="true">&rarr;</span></span>' +
                '</a>';
        }

        root.innerHTML =
            '<header class="wl-lm-head">' +
            '  <div>' +
            '    <h1 class="wl-lm-title">Get more from your wishlists</h1>' +
            '    <div class="wl-lm-rule" aria-hidden="true"></div>' +
            '    <p class="wl-lm-sub">Everything you need to know about managing your lists, getting alerts ' +
            'and making the most of your wishlist.</p>' +
            '  </div>' +
            '  <div class="wl-lm-art" aria-hidden="true">' + WL_GATE_STASH + '</div>' +
            '</header>' +
            '<div class="wl-lm-cards">' + cards + '</div>' +
            (panels ? '<div class="wl-lm-panels">' + panels + '</div>' : '');
    }

    function renderLearnMoreBlocks() {
        var blocks = document.querySelectorAll('[data-wl-learn-more]');
        for (var i = 0; i < blocks.length; i++) {
            try {
                renderLearnMore(blocks[i]);
            } catch (e) {
                console.error('[WL] learn more render failed', e);
            }
        }
    }

    // Run standalone rather than inside the settings fetch. This page is static
    // content that needs no config, and the .then() chain has no .catch() — so
    // anything throwing earlier in it silently left the block on "Loading…",
    // which is exactly what happened.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', renderLearnMoreBlocks);
    } else {
        renderLearnMoreBlocks();
    }

    document.addEventListener('click', function (e) {
        var head = e.target.closest && e.target.closest('[data-wl-lm-toggle]');
        if (!head) return;
        e.preventDefault();
        var card = head.parentNode;
        var body = card.querySelector('.wl-lm-card-body');
        var open = body.hidden;
        body.hidden = !open;
        head.setAttribute('aria-expanded', String(open));
        card.classList.toggle('is-open', open);
    });

    // ── Wishlist detail ───────────────────────────────────────────────────
    // Product data is resolved up front rather than patched in after render.
    // The filters, the chip counts and the summary all depend on stock and
    // sale state, and painting them twice — once empty, once correct — reads
    // as a bug. fetchProductInfo caches, so this is one parallel round.
    var _dtSearch = '';
    var _dtFilter = 'all';
    var _dtSort = 'recent';

    var WL_DT_SORTS = [
        { value: 'recent', label: 'Recently added' },
        { value: 'priceLow', label: 'Price: low to high' },
        { value: 'priceHigh', label: 'Price: high to low' },
        { value: 'name', label: 'Name A–Z' }
    ];

    var WL_DT_ICONS = {
        search:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" aria-hidden="true"><circle cx="10.6" cy="10.6" r="6.6"/>' +
            '<path d="M15.4 15.4L20 20"/></svg>',
        cart:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="9.5" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/>' +
            '<path d="M2.5 3h2.8l2.4 11.4a1.6 1.6 0 0 0 1.6 1.3h8.3a1.6 1.6 0 0 0 1.6-1.2L21 7H6"/></svg>',
        van:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M2.6 6.4h10.2v9.2H2.6z"/><path d="M12.8 9.6h4l3 3v3h-7z"/>' +
            '<circle cx="6.4" cy="18" r="1.7"/><circle cx="16.6" cy="18" r="1.7"/></svg>',
        arrowDown:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M17 7L9 15M9 15h5M9 15v-5"/></svg>'
    };

    // Storefront product JSON gives availability and sale state but not
    // inventory levels, so "low stock" is deliberately absent — it cannot be
    // derived here without inventing it.
    function itemMeta(item) {
        var info = productCache[item.productHandle] || null;
        var priceAtAdd = parseFloat(item.priceAtAdd || 0);
        if (!info) {
            return {
                info: null, title: item.productHandle || 'Product',
                price: priceAtAdd, priceAtAdd: priceAtAdd, compare: 0,
                available: false, preorder: false, onSale: false, dropped: false, meta: ''
            };
        }

        var variantId = String(item.shopifyVariantId || '');
        var v = null;
        if (variantId && info.variants) {
            v = info.variants.filter(function (x) { return String(x.id) === variantId; })[0];
        }
        var price = ((v ? v.price : info.price) || 0) / 100;
        var compare = ((v ? v.compare_at_price : info.compare_at_price) || 0) / 100;
        var available = v ? !!v.available : !!info.available;

        // "1:14" style tags become the scale in the meta line; anything else is
        // left out rather than guessed at.
        var scale = '';
        var tags = info.tags || [];
        for (var t = 0; t < tags.length; t++) {
            if (/^1\s*[:\/]\s*\d+$/.test(String(tags[t]))) {
                scale = String(tags[t]).replace(/\s/g, '') + ' Scale';
                break;
            }
        }
        var bits = [info.vendor, info.type, scale].filter(Boolean);

        return {
            info: info,
            title: info.title || item.productHandle,
            price: price,
            priceAtAdd: priceAtAdd,
            available: available,
            preorder: info.preorder === true,
            compare: compare,
            onSale: compare > price,
            dropped: priceAtAdd > 0 && price > 0 && price < priceAtAdd,
            meta: bits.join(' • '),
            preorderText: info.preorderText || ''
        };
    }

    function detailVisibleItems(wl) {
        var items = (wl.items || []).slice();
        var q = _dtSearch.trim().toLowerCase();

        var out = items.filter(function (it) {
            var m = itemMeta(it);
            if (_dtFilter === 'in' && (!m.available || m.preorder)) return false;
            if (_dtFilter === 'preorder' && (!m.available || !m.preorder)) return false;
            if (_dtFilter === 'out' && m.available) return false;
            if (_dtFilter === 'dropped' && !m.dropped) return false;
            if (q && String(m.title).toLowerCase().indexOf(q) === -1) return false;
            return true;
        });

        out.sort(function (a, b) {
            var ma = itemMeta(a), mb = itemMeta(b);
            if (_dtSort === 'priceLow') return ma.price - mb.price;
            if (_dtSort === 'priceHigh') return mb.price - ma.price;
            if (_dtSort === 'name') return String(ma.title).localeCompare(String(mb.title));
            return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
        });
        return out;
    }

    function detailCounts(wl) {
        var items = wl.items || [];
        var c = { all: items.length, in: 0, preorder: 0, out: 0, dropped: 0, total: 0, rrp: 0 };
        for (var i = 0; i < items.length; i++) {
            var m = itemMeta(items[i]);
            if (m.available && m.preorder) c.preorder++;
            else if (m.available) c.in++; else c.out++;
            if (m.dropped) c.dropped++;
            var paid = m.price || m.priceAtAdd;
            c.total += paid;
            // Falls back to the selling price where there is no RRP, so the
            // comparison stays like-for-like across a mixed list.
            c.rrp += m.compare > paid ? m.compare : paid;
        }
        c.saving = Math.round((c.rrp - c.total) * 100) / 100;
        return c;
    }

    function renderDetailItemRow(wl, it) {
        var m = itemMeta(it);
        var qtyEnabled = wlConfig && wlConfig.manageQuantity === true;
        var bulkEnabled = wlConfig && wlConfig.bulkActions === true;
        var variantEnabled = wlConfig && wlConfig.chooseVariant === true;
        var handle = escHtml(it.productHandle || '');

        // Only two states worth badging: whether they can buy it, and whether it
        // has come down since they saved it. The second is the one they care
        // about and it comes from our own data, not the catalogue's RRP.
        var badge = '';
        if (!m.info) {
            badge = '<span class="wl-dt-badge wl-dt-badge--out">Check availability</span>';
        } else if (!m.available) {
            badge = '<span class="wl-dt-badge wl-dt-badge--out">Out of stock</span>';
        } else if (m.preorder) {
            badge = '';
        } else if (m.dropped) {
            badge = '<span class="wl-dt-badge wl-dt-badge--drop">' + WL_DT_ICONS.arrowDown + 'Price dropped</span>';
        } else {
            badge = '<span class="wl-dt-badge wl-dt-badge--in">In stock</span>';
        }

        // Struck RRP beside the price, the way the storefront shows it. Shown
        // only when there genuinely is one above the selling price.
        var priceHtml = '<p class="wl-dt-price">' + formatMoney(m.price || m.priceAtAdd) +
            (m.compare > (m.price || 0)
                ? ' <s class="wl-dt-rrp">' + formatMoney(m.compare) + '</s>'
                : '') +
            '</p>';
        if (m.dropped) {
            priceHtml += '<p class="wl-dt-was">Was ' + formatMoney(m.priceAtAdd) +
                ' when you saved it</p>';
        }

        var action = m.available
            ? '<button type="button" class="wl-dt-btn wl-dt-btn--solid" data-wl-move-to-cart ' +
              'data-wishlist-id="' + escHtml(wl.id) + '" data-product-id="' + escHtml(it.shopifyProductId) + '" ' +
              'data-variant-id="' + escHtml(it.shopifyVariantId || '') + '" data-handle="' + handle + '">' + (m.preorder ? 'Pre-order' : 'Add to basket') + '</button>'
            : '<button type="button" class="wl-dt-btn wl-dt-btn--disabled" disabled>' + (m.info ? 'Out of stock' : 'Check availability') + '</button>';

        var second = m.available
            ? '<button type="button" class="wl-dt-btn wl-dt-btn--ghost" data-wl-move-list ' +
              'data-wishlist-id="' + escHtml(wl.id) + '" data-product-id="' + escHtml(it.shopifyProductId) + '" ' +
              'data-handle="' + handle + '">Move to another list</button>'
            : '<a class="wl-dt-btn wl-dt-btn--ghost" href="/products/' + handle + '">View product</a>';

        return '' +
        '<article class="wl-dt-row' + (m.preorder ? ' wl-dt-row--preorder' : '') + '" data-product-id="' + escHtml(it.shopifyProductId) + '" ' +
        '         data-variant-id="' + escHtml(it.shopifyVariantId || '') + '" data-handle="' + handle + '" data-qty="1">' +
        (bulkEnabled
            ? '  <label class="wl-dt-check" aria-label="Select item"><input type="checkbox" data-wl-item-checkbox /></label>'
            : '') +
        '  <a class="wl-dt-thumb" href="/products/' + handle + '" tabindex="-1" aria-hidden="true">' +
        (m.info && m.info.featured_image
            ? '<img src="' + escHtml(m.info.featured_image) + '" alt="" loading="lazy" />'
            : '') +
        '  </a>' +
        '  <div class="wl-dt-main">' +
        '    <p class="wl-dt-title"><a href="/products/' + handle + '">' + escHtml(m.title) + '</a></p>' +
        (m.meta ? '    <p class="wl-dt-meta">' + escHtml(m.meta) + '</p>' : '') +
        priceHtml +
        '  </div>' +
        (badge ? '  <div class="wl-dt-status">' + badge + '</div>' : '') +
        '  <div class="wl-dt-qty">' +
        (qtyEnabled
            ? '<div class="wl-detail-item-qty" data-qty-slot>' +
              '<button type="button" class="wl-qty-btn" data-wl-qty-dec aria-label="Decrease quantity">&minus;</button>' +
              '<input type="text" class="wl-qty-input" data-wl-qty-input value="1" readonly aria-label="Quantity" />' +
              '<button type="button" class="wl-qty-btn" data-wl-qty-inc aria-label="Increase quantity">+</button>' +
              '</div>'
            : '') +
        (variantEnabled ? '<div class="wl-detail-item-variant" data-variant-slot hidden></div>' : '') +
        '  </div>' +
        '  <div class="wl-dt-actions">' + action + second + '</div>' +
        '  <button type="button" class="wl-dt-remove" data-wl-remove-item ' +
        '          data-wishlist-id="' + escHtml(wl.id) + '" data-product-id="' + escHtml(it.shopifyProductId) + '" ' +
        '          aria-label="Remove ' + escHtml(m.title) + '">&times;</button>' +
        '</article>';
    }

    // A list is "on" when every item in it is. One item opted out reads as off,
    // which is the honest summary — clicking then switches the whole list.
    function alertStateFor(wl, field) {
        var items = wl.items || [];
        if (!items.length) return true;
        for (var i = 0; i < items.length; i++) {
            if (items[i][field] === false) return false;
        }
        return true;
    }

    function renderAlertToggle(wl, field, variant, art, label) {
        var on = alertStateFor(wl, field);
        return '<button type="button" class="wl-dt-alert wl-dt-alert--' + variant +
            (on ? '' : ' is-off') + '" data-wl-alert-toggle="' + field +
            '" data-wishlist-id="' + escHtml(wl.id) + '" role="switch" aria-checked="' + on + '">' +
            '<span class="wl-dt-alert-art" aria-hidden="true">' + (art || '') + '</span>' +
            '<span class="wl-dt-alert-label">' + escHtml(label) + '</span>' +
            '<span class="wl-dt-alert-track" aria-hidden="true">' +
            '<span class="wl-dt-alert-knob"></span></span>' +
            '</button>';
    }

    function renderDetailSidebar(wl, counts, learnMore, deliveryNote) {
        var tips = [
            { art: 'tag', title: 'Keep track of price drops', text: 'We will email you when prices drop on items in this list.' },
            { art: 'box', title: 'Know when it is back in stock', text: 'Get notified the moment out-of-stock items are available again.' },
            { art: 'heart', title: 'Organise your projects', text: 'Create multiple lists for different builds, themes or ideas.' }
        ];

        var tipRows = '';
        for (var i = 0; i < tips.length; i++) {
            tipRows +=
                '<li class="wl-dt-tip">' +
                '  <span class="wl-dt-tip-art" aria-hidden="true">' + (WL_GATE_ART[tips[i].art] || '') + '</span>' +
                '  <div>' +
                '    <p class="wl-dt-tip-title">' + escHtml(tips[i].title) + '</p>' +
                '    <p class="wl-dt-tip-text">' + escHtml(tips[i].text) + '</p>' +
                '  </div>' +
                '</li>';
        }

        return '' +
        '<aside class="wl-dt-side">' +
        '  <section class="wl-dt-card wl-dt-card--tips">' +
        '    <h2 class="wl-dt-card-title"><span class="wl-dt-card-icon" aria-hidden="true">' +
        WL_OV_ICONS.bulb + '</span>Tips for using your wishlist</h2>' +
        '    <ul class="wl-dt-tips">' + tipRows + '</ul>' +
        (learnMore
            ? '    <a class="wl-dt-learn" href="' + escHtml(learnMore) + '">Learn more about wishlists <span aria-hidden="true">&rarr;</span></a>'
            : '') +
        '  </section>' +
        '  <section class="wl-dt-card">' +
        '    <h2 class="wl-dt-card-title">List summary</h2>' +
        '    <dl class="wl-dt-summary">' +
        '      <div><dt>Total items</dt><dd>' + counts.all + '</dd></div>' +
        '      <div><dt>In stock</dt><dd>' + counts.in + '</dd></div>' +
        '      <div><dt>Pre-orders</dt><dd>' + counts.preorder + '</dd></div>' +
        '      <div><dt>Out of stock</dt><dd>' + counts.out + '</dd></div>' +
        '      <div><dt>Price dropped</dt><dd>' + counts.dropped + '</dd></div>' +
        '    </dl>' +
        '    <div class="wl-dt-summary-total"><span>Total</span>' +
        '      <span class="wl-dt-summary-amounts">' +
        (counts.saving > 0 ? '<s class="wl-dt-summary-rrp">' + formatMoney(counts.rrp) + '</s>' : '') +
        '        <strong>' + formatMoney(counts.total) + '</strong>' +
        '      </span>' +
        '    </div>' +
        (counts.saving > 0
            ? '    <p class="wl-dt-summary-saving">You save ' + formatMoney(counts.saving) + '</p>'
            : '') +
        (deliveryNote
            ? '    <p class="wl-dt-delivery"><span class="wl-dt-delivery-art" aria-hidden="true">' +
              WL_DT_ICONS.van + '</span>' + escHtml(deliveryNote) + '</p>'
            : '') +
        '  </section>' +
        '</aside>';
    }

    function paintDetailBody(root, wl) {
        var counts = detailCounts(wl);
        var visible = detailVisibleItems(wl);
        var learnMore = root.getAttribute('data-learn-more-url') || '';
        var deliveryNote = root.getAttribute('data-delivery-note') || '';

        var chips = [
            { key: 'all', label: 'All items', n: counts.all },
            { key: 'in', label: 'In stock', n: counts.in },
            { key: 'preorder', label: 'Pre-orders', n: counts.preorder },
            { key: 'out', label: 'Out of stock', n: counts.out },
            { key: 'dropped', label: 'Price dropped', n: counts.dropped }
        ];
        var chipHtml = '';
        for (var c = 0; c < chips.length; c++) {
            chipHtml +=
                '<button type="button" class="wl-dt-chip' + (_dtFilter === chips[c].key ? ' is-active' : '') +
                '" data-wl-filter="' + chips[c].key + '" aria-pressed="' + (_dtFilter === chips[c].key) + '">' +
                escHtml(chips[c].label) + ' (' + chips[c].n + ')</button>';
        }

        var sortHtml = '<select class="wl-dt-sort-select" data-wl-detail-sort aria-label="Sort items">';
        for (var s = 0; s < WL_DT_SORTS.length; s++) {
            sortHtml += '<option value="' + WL_DT_SORTS[s].value + '"' +
                (WL_DT_SORTS[s].value === _dtSort ? ' selected' : '') + '>' +
                escHtml(WL_DT_SORTS[s].label) + '</option>';
        }
        sortHtml += '</select>';

        var rows = '';
        if (!visible.length) {
            rows = '<p class="wl-dt-empty">' +
                (counts.all === 0 ? 'This list is empty.' : 'Nothing here matches that filter.') +
                '</p>';
        } else {
            for (var i = 0; i < visible.length; i++) rows += renderDetailItemRow(wl, visible[i]);
        }

        var body = root.querySelector('[data-wl-detail-body]');
        if (!body) return;
        body.innerHTML =
            '<div class="wl-dt-layout">' +
            '  <div class="wl-dt-main-col">' +
            '    <div class="wl-dt-toolbar">' +
            '      <div class="wl-dt-search">' + WL_DT_ICONS.search +
            '        <input type="search" class="wl-dt-search-input" data-wl-detail-search ' +
            '               placeholder="Search within this list..." value="' + escHtml(_dtSearch) + '" ' +
            '               aria-label="Search within this list" />' +
            '      </div>' +
            '      <div class="wl-dt-chips">' + chipHtml + '</div>' +
            '      <div class="wl-dt-sort"><span class="wl-dt-sort-label">Sort by</span>' + sortHtml + '</div>' +
            '    </div>' +
            '    <div class="wl-dt-rows">' + rows + '</div>' +
            '  </div>' +
            renderDetailSidebar(wl, counts, learnMore, deliveryNote) +
            '</div>';

        // Variant selectors still come from the shared hydration path.
        if (wlConfig && wlConfig.chooseVariant === true) hydrateDetailItems(body, wl);
    }

    function renderDetailView(root, wl) {
        if (!wl) {
            root.innerHTML =
                '<div class="wl-detail-notfound">' +
                '  <a class="wl-detail-back" href="/pages/wishlist">&larr; Back to all lists</a>' +
                '  <h2>List not found</h2>' +
                '  <p>This wishlist is no longer available.</p>' +
                '</div>';
            return;
        }

        var items = wl.items || [];
        var lastUpdated = wl.updatedAt || wl.createdAt;
        var id = escHtml(wl.id);

        var actions =
            '<button type="button" class="wl-dt-hero-btn wl-dt-hero-btn--solid" data-wl-add-all data-wishlist-id="' + id + '">' +
            WL_DT_ICONS.cart + 'Add all available to basket</button>' +
            '<button type="button" class="wl-dt-hero-btn" data-wl-edit-list data-wishlist-id="' + id +
            '" data-wishlist-name="' + escHtml(wl.name) + '">' + WL_OV_ICONS.pencil + 'Edit list</button>' +
            (wlConfig.shareWishlist !== false
                ? '<button type="button" class="wl-dt-hero-btn" data-wl-share-list data-wishlist-id="' + id + '">' +
                  WL_OV_ICONS.share + 'Share</button>'
                : '') +
            '<button type="button" class="wl-dt-hero-btn wl-dt-hero-btn--danger" data-wl-delete-list data-wishlist-id="' + id + '">' +
            WL_OV_ICONS.trash + 'Delete</button>';

        root.innerHTML =
            (IS_LOGGED_IN ? '' : renderGuestBanner()) +
            '<a class="wl-detail-back" href="/pages/wishlist">&larr; Back to all lists</a>' +
            '<section class="wl-dt-hero">' +
            '  <div class="wl-dt-hero-copy">' +
            '    <span class="wl-dt-hero-badge" aria-hidden="true">' + WL_OV_ICONS.bookmark + '</span>' +
            '    <div>' +
            '      <h1 class="wl-dt-hero-title">' + escHtml(wl.name) +
            '        <span class="wl-dt-hero-count">(' + items.length + (items.length === 1 ? ' item' : ' items') + ')</span></h1>' +
            '      <p class="wl-dt-hero-updated">Last updated: ' + escHtml(lastUpdated ? formatDate(lastUpdated) : '') + '</p>' +
            '      <p class="wl-dt-hero-total">Total: <strong data-wl-hero-total>&hellip;</strong></p>' +
            '      <p class="wl-dt-hero-sub">' +
            escHtml(wl.description || 'Your saved kits, tools and project ideas in one place.') +
            '      </p>' +
            (items.length
                ? '      <div class="wl-dt-alerts">' +
                  renderAlertToggle(wl, 'notifyPriceDrop', 'drop', WL_GATE_ART.tag, 'Price drop alerts') +
                  renderAlertToggle(wl, 'notifyRestock', 'stock', WL_GATE_ART.box, 'Back in stock alerts') +
                  '      </div>'
                : '') +
            '    </div>' +
            '  </div>' +
            '  <div class="wl-dt-hero-actions">' + actions + '</div>' +
            '</section>' +
            '<div data-wl-detail-body><p class="wl-dt-loading">Loading your list&hellip;</p></div>';

        // Resolve every product once, then paint. Counts and filters are only
        // meaningful with stock and price known, so painting before they land
        // would show numbers that immediately change.
        var handles = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i].productHandle) handles.push(items[i].productHandle);
        }
        Promise.all(handles.map(fetchProductInfo)).then(function () {
            if (!root.isConnected) return;
            var heroCounts = detailCounts(wl);
            var totalEl = root.querySelector('[data-wl-hero-total]');
            if (totalEl) {
                totalEl.innerHTML = formatMoney(heroCounts.total) +
                    (heroCounts.saving > 0
                        ? ' <s class="wl-dt-hero-rrp">' + formatMoney(heroCounts.rrp) + '</s>'
                        : '');
            }
            paintDetailBody(root, wl);
        });
    }

    // An open box with a heart above it — the illustration from the design,
    // drawn inline so the empty state costs nothing to load.
    var WL_EMPTY_ART =
        '<svg viewBox="0 0 220 190" fill="none" aria-hidden="true">' +
        '<path d="M110 30c-7-11-25-9-27 5-1 10 9 18 27 30 18-12 28-20 27-30-2-14-20-16-27-5z" fill="#f6cfd3"/>' +
        '<path d="M36 96l74-26 74 26-74 27z" fill="#f3f2f1"/>' +
        '<path d="M36 96v46l74 27v-46z" fill="#e9e7e5"/>' +
        '<path d="M184 96v46l-74 27v-46z" fill="#dedbd8"/>' +
        '<path d="M36 96l74-26 74 26-74 27z" stroke="#cfcbc7" stroke-width="2.4" stroke-linejoin="round"/>' +
        '<path d="M36 96v46l74 27 74-27V96" stroke="#cfcbc7" stroke-width="2.4" stroke-linejoin="round"/>' +
        '<path d="M110 123v46" stroke="#cfcbc7" stroke-width="2.4"/>' +
        '<path d="M158 34l4 10 10 4-10 4-4 10-4-10-10-4 10-4z" fill="#f6cfd3"/>' +
        '<path d="M56 48l3 7 7 3-7 3-3 7-3-7-7-3 7-3z" fill="#f6cfd3"/>' +
        '</svg>';

    function renderEmptyState(root) {
        var emptyHeading = root.getAttribute('data-empty-heading') || 'Your wishlist is looking a little empty';
        var emptyBody = root.getAttribute('data-empty-body') ||
            'Add some items you love and start building your next project.';
        var emptyCta = root.getAttribute('data-empty-cta') || 'Start adding items';

        // A signed-out visitor may simply be on the wrong device — their list
        // could be sitting on their account. Saying "empty" without offering
        // the way back to it is misleading.
        var signedOutHelp = '';
        if (!IS_LOGGED_IN) {
            var back = '/';
            try { back = window.location.pathname + window.location.search; } catch (e) {}
            signedOutHelp =
                '<p class="wl-empty-signin">Already saved things? ' +
                '<a href="/customer_authentication/login?return_to=' + encodeURIComponent(back) +
                '">Sign in to see your wishlist</a></p>';
        }

        root.innerHTML =
            '<div class="wl-empty">' +
            '  <div class="wl-empty-art" aria-hidden="true">' + WL_EMPTY_ART + '</div>' +
            '  <h2 class="wl-empty-title">' + escHtml(emptyHeading) + '</h2>' +
            '  <p class="wl-empty-text">' + escHtml(emptyBody) + '</p>' +
            '  <div class="wl-empty-actions">' +
            '    <button type="button" class="wl-empty-btn wl-empty-btn--solid" data-action="open-create-modal">' +
            escHtml(emptyCta) + '</button>' +
            '    <a class="wl-empty-btn wl-empty-btn--ghost" href="/collections/all">Shop now</a>' +
            '  </div>' +
            signedOutHelp +
            '</div>';
    }

    // Icons used by the wishlist overview. Line art at 1.6 stroke to match the
    // signup gate; the stash mark stays filled because it is the featured one.
    var WL_OV_ICONS = {
        bookmark:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M6 3.6h12a1 1 0 0 1 1 1v16.2l-7-4.4-7 4.4V4.6a1 1 0 0 1 1-1z"/></svg>',
        plus:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="9"/><path d="M12 8.4v7.2M8.4 12h7.2"/></svg>',
        kebab:
            '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
            '<circle cx="12" cy="5.4" r="1.7"/><circle cx="12" cy="12" r="1.7"/>' +
            '<circle cx="12" cy="18.6" r="1.7"/></svg>',
        bulb:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M9.2 18h5.6M10 21h4"/>' +
            '<path d="M12 3a6 6 0 0 0-3.4 10.9c.6.4.9 1 .9 1.7v.4h5v-.4c0-.7.3-1.3.9-1.7A6 6 0 0 0 12 3z"/>' +
            '</svg>',
        pencil:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
        share:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/>' +
            '<circle cx="18" cy="19" r="2.6"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>',
        trash:
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M3.5 6h17M19 6l-1.4 13.2a2 2 0 0 1-2 1.8H8.4a2 2 0 0 1-2-1.8L5 6"/>' +
            '<path d="M10 10.5v6M14 10.5v6M9 6V4.2A1.2 1.2 0 0 1 10.2 3h3.6A1.2 1.2 0 0 1 15 4.2V6"/></svg>'
    };

    var WL_OV_BENEFITS = [
        {
            feature: true,
            title: 'Build your wishlist',
            text: 'Create separate lists for future builds, projects, paints, gift ideas or anything else you are planning.'
        },
        { art: 'heart', title: 'All in one place', text: 'Access your lists on any device, anytime.' },
        { art: 'tag', title: 'Price drop alerts', text: 'We will email you when prices drop.' },
        { art: 'box', title: 'Back in stock alerts', text: 'Know when sold-out items are available.' }
    ];

    var WL_OV_TIPS = [
        { title: 'Build your wishlist', text: 'Create separate lists for future builds, projects, paints or gift ideas.' }
    ];

    // Sort is view state, not stored — it resets on reload, which is what a
    // shopper expects from a control that isn't tied to their account.
    var _ovSort = 'recent';

    var WL_OV_SORTS = [
        { value: 'recent', label: 'Recently updated' },
        { value: 'name', label: 'Name A–Z' },
        { value: 'items', label: 'Most items' },
        { value: 'total', label: 'Highest total' }
    ];

    // One source for every total on this page, so the value sort, the
    // compact row and the full row cannot disagree. Falls back to the price
    // at add for anything not yet resolved, which is what it used to use
    // throughout.
    function listTotal(wl) {
        return listTotals(wl).total;
    }

    // The RRP side of a list total is only trustworthy once every item in
    // that list has resolved: the overview pre-loads five thumbnails per
    // list, so a partial total would understate the saving, and a saving
    // that is quietly too small is worse than none at all. Rows report
    // whether they are complete and the caller decides what to show.
    function listTotals(wl) {
        var items = wl.items || [];
        var total = 0;
        var rrp = 0;
        var complete = true;
        for (var i = 0; i < items.length; i++) {
            var m = itemMeta(items[i]);
            if (!m.info) complete = false;
            var paid = m.price || m.priceAtAdd;
            total += paid;
            // Falls back to the selling price where there is no RRP, so the
            // comparison stays like-for-like across a mixed list.
            rrp += m.compare > paid ? m.compare : paid;
        }
        return {
            total: total,
            rrp: rrp,
            saving: Math.round((rrp - total) * 100) / 100,
            complete: complete
        };
    }

    function overviewTotalHtml(wl) {
        var t = listTotals(wl);
        var show = t.complete && t.saving > 0;
        return 'List total: ' +
            (show ? '<s class="wl-ov-row-rrp">' + formatMoney(t.rrp) + '</s> ' : '') +
            '<strong>' + formatMoney(t.total) + '</strong>' +
            (show
                ? '<span class="wl-ov-row-save">You save ' + formatMoney(t.saving) + '</span>'
                : '');
    }

    function sortedWishlists() {
        var out = state.wishlists.slice();
        out.sort(function (a, b) {
            if (_ovSort === 'name') {
                return String(a.name || '').localeCompare(String(b.name || ''));
            }
            if (_ovSort === 'items') {
                return (b.items || []).length - (a.items || []).length;
            }
            if (_ovSort === 'total') {
                return listTotal(b) - listTotal(a);
            }
            return new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0);
        });
        return out;
    }

    function renderOverviewBenefits(learnMore) {
        var html = '<ul class="wl-ov-benefits">';
        for (var i = 0; i < WL_OV_BENEFITS.length; i++) {
            var b = WL_OV_BENEFITS[i];
            var art = b.feature ? WL_GATE_STASH : (WL_GATE_ART[b.art] || '');
            html +=
                '<li class="wl-ov-benefit' + (b.feature ? ' wl-ov-benefit--feature' : '') + '">' +
                '  <div class="wl-ov-benefit-art" aria-hidden="true">' + art + '</div>' +
                '  <div class="wl-ov-benefit-copy">' +
                '    <p class="wl-ov-benefit-title">' + escHtml(b.title) + '</p>' +
                '    <p class="wl-ov-benefit-text">' + escHtml(b.text) + '</p>' +
                (b.feature && learnMore
                    ? '    <a class="wl-ov-benefit-link" href="' + escHtml(learnMore) +
                      '">Learn more <span aria-hidden="true">&rarr;</span></a>'
                    : '') +
                '  </div>' +
                '</li>';
        }
        return html + '</ul>';
    }

    function renderOverviewThumbs(items) {
        var maxThumbs = 5;
        var shown = Math.min(items.length, maxThumbs);
        var overflow = items.length > maxThumbs ? items.length - maxThumbs : 0;

        var html = '<div class="wl-ov-thumbs">';
        for (var t = 0; t < shown; t++) {
            html +=
                '<div class="wl-card-thumb-tile wl-ov-thumb" data-handle="' +
                escHtml(items[t].productHandle || '') + '"></div>';
        }
        if (overflow > 0) {
            html +=
                '<div class="wl-card-thumb-tile wl-card-thumb-overflow wl-ov-thumb wl-ov-thumb--more">' +
                '+' + overflow + '</div>';
        }
        return html + '</div>';
    }

    function renderOverviewRow(wl) {
        var items = wl.items || [];
        var lastUpdated = wl.updatedAt || wl.createdAt;
        var lastUpdatedLabel = lastUpdated ? formatDate(lastUpdated) : '';
        var id = escHtml(wl.id);

        var menu =
            '<div class="wl-ov-menu">' +
            '  <button type="button" class="wl-ov-menu-btn" data-wl-menu-btn aria-haspopup="true" ' +
            '          aria-expanded="false" aria-label="More actions for ' + escHtml(wl.name) + '">' +
            WL_OV_ICONS.kebab +
            '  </button>' +
            '  <div class="wl-ov-menu-pop" hidden>' +
            '    <button type="button" class="wl-ov-menu-item" data-wl-edit-list data-wishlist-id="' + id +
            '            " data-wishlist-name="' + escHtml(wl.name) + '">' + WL_OV_ICONS.pencil + 'Rename list</button>' +
            (wlConfig.shareWishlist !== false
                ? '    <button type="button" class="wl-ov-menu-item" data-wl-share-list data-wishlist-id="' + id +
                  '">' + WL_OV_ICONS.share + 'Share list</button>'
                : '') +
            '    <button type="button" class="wl-ov-menu-item wl-ov-menu-item--danger" data-wl-delete-list ' +
            '            data-wishlist-id="' + id + '">' + WL_OV_ICONS.trash + 'Delete list</button>' +
            '  </div>' +
            '</div>';

        return '' +
            '<li class="wl-ov-row">' +
            '  <span class="wl-ov-row-badge" aria-hidden="true">' + WL_OV_ICONS.bookmark + '</span>' +
            '  <div class="wl-ov-row-meta">' +
            '    <p class="wl-ov-row-name">' + escHtml(wl.name) +
            '      <span class="wl-ov-row-chip">' + items.length + (items.length === 1 ? ' item' : ' items') + '</span>' +
            '    </p>' +
            (wl.description
                ? '    <p class="wl-ov-row-desc">' + escHtml(wl.description) + '</p>'
                : '') +
            '    <p class="wl-ov-row-updated">Last updated: ' + escHtml(lastUpdatedLabel) + '</p>' +
            '    <p class="wl-ov-row-total" data-wl-total-for="' + id + '">' +
            overviewTotalHtml(wl) + '</p>' +
            '    <p class="wl-ov-row-compact">' +
            escHtml(lastUpdated ? formatRelativeDate(lastUpdated) : '') +
            '      <span aria-hidden="true">&middot;</span> ' + formatMoney(listTotal(wl)) + '</p>' +
            '  </div>' +
            renderOverviewThumbs(items) +
            '  <span class="wl-ov-row-chevron" aria-hidden="true">' +
            '    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
            'stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' +
            '  </span>' +
            '  <div class="wl-ov-row-actions">' +
            '    <a class="wl-ov-btn wl-ov-btn--ghost wl-card-link" href="/pages/wishlist?list=' + id + '">View list</a>' +
            '    <button type="button" class="wl-ov-btn wl-ov-btn--solid" data-wl-add-all data-wishlist-id="' + id +
            '">Add all to basket</button>' +
            menu +
            '  </div>' +
            '</li>';
    }

    // ── Most wishlisted ───────────────────────────────────────────────────
    // A section under the customer's own lists rather than a page of its own:
    // it is a browsing prompt, and it gets seen here.
    var _trendingHandles = null;

    // Ten rows shown, but two filters run after the server answers: the
    // customer's own saves are removed, and any product that no longer
    // resolves on the storefront is dropped. Asking for exactly ten
    // guarantees fewer than ten, so ask for a surplus and cut it back after
    // both filters have had their say.
    var WL_TRENDING_SHOWN = 10;
    var WL_TRENDING_CANDIDATES = 20;

    function renderTrendingSection(root) {
        var host = root.querySelector('[data-wl-trending]');
        if (!host || !_trendingHandles || !_trendingHandles.length) return;

        var rows = '';
        for (var i = 0; i < _trendingHandles.length; i++) {
            var info = productCache[_trendingHandles[i]];
            if (!info) continue;
            var handle = escHtml(_trendingHandles[i]);
            rows +=
                '<li class="wl-tr-row">' +
                '  <span class="wl-tr-rank" aria-hidden="true">' + (i + 1) + '</span>' +
                '  <a class="wl-tr-thumb" href="/products/' + handle + '" tabindex="-1" aria-hidden="true">' +
                (info.featured_image ? '<img src="' + escHtml(info.featured_image) + '" alt="" loading="lazy" />' : '') +
                '  </a>' +
                '  <a class="wl-tr-title" href="/products/' + handle + '">' + escHtml(info.title || handle) + '</a>' +
                '  <span class="wl-tr-price">' + formatMoney((info.price || 0) / 100) + '</span>' +
                '  <span class="wl-tr-heart" data-wl-trending-heart="' + handle + '"></span>' +
                '</li>';
        }
        if (!rows) return;

        host.innerHTML =
            '<h2 class="wl-tr-title-main">Most wishlisted right now</h2>' +
            '<p class="wl-tr-sub">The models, tools and kits other modellers are saving.</p>' +
            '<ol class="wl-tr-list">' + rows + '</ol>';

        // Hearts are the same control used everywhere else, so adding from here
        // behaves exactly as it does on a collection card.
        var slots = host.querySelectorAll('[data-wl-trending-heart]');
        for (var k = 0; k < slots.length; k++) {
            var h = slots[k].getAttribute('data-wl-trending-heart');
            var pi = productCache[h];
            if (!pi) continue;
            var gid = 'gid://shopify/Product/' + pi.id;
            var hb = createHeartBtn(gid, String((pi.variants && pi.variants[0] && pi.variants[0].id) || ''), h,
                String(((pi.variants && pi.variants[0] && pi.variants[0].price) || 0) / 100));
            hb.classList.add('wl-heart-btn--inline');
            slots[k].appendChild(hb);
        }
    }

    function loadTrendingSection(root) {
        if (_trendingHandles) { renderTrendingSection(root); return; }
        fetchApi('api/wishlists/trending?limit=40')
            .then(function (data) {
                var handles = (data && data.handles) || [];
                // Their own saved items are not a discovery prompt.
                var mine = {};
                (state.wishlists || []).forEach(function (w) {
                    (w.items || []).forEach(function (it) { mine[it.productHandle] = true; });
                });
                var candidates = handles
                    .filter(function (h) { return !mine[h]; })
                    .slice(0, WL_TRENDING_CANDIDATES);

                // fetchProductInfo resolves null rather than rejecting, so a
                // deleted or unpublished product costs us a row, not the
                // whole section.
                return Promise.all(candidates.map(function (h) { return fetchProductInfo(h); }))
                    .then(function () {
                        // Keep only what can actually be drawn, so the ranks
                        // run 1-10 with no gaps.
                        _trendingHandles = candidates
                            .filter(function (h) { return !!productCache[h]; })
                            .slice(0, WL_TRENDING_SHOWN);
                    });
            })
            .then(function () { renderTrendingSection(root); })
            .catch(function () {});
    }

    function renderOverview(root) {
        var lists = sortedWishlists();
        var learnMore = root.getAttribute('data-learn-more-url') || '';

        var sortHtml = '<select class="wl-ov-sort-select" data-wl-sort aria-label="Sort wishlists">';
        for (var s = 0; s < WL_OV_SORTS.length; s++) {
            sortHtml +=
                '<option value="' + WL_OV_SORTS[s].value + '"' +
                (WL_OV_SORTS[s].value === _ovSort ? ' selected' : '') + '>' +
                escHtml(WL_OV_SORTS[s].label) + '</option>';
        }
        sortHtml += '</select>';

        var rows = '';
        for (var i = 0; i < lists.length; i++) rows += renderOverviewRow(lists[i]);

        var tip =
            '<div class="wl-ov-tip">' +
            '  <span class="wl-ov-tip-icon" aria-hidden="true">' + WL_OV_ICONS.bulb + '</span>' +
            '  <div class="wl-ov-tip-copy">' +
            '    <p class="wl-ov-tip-title">Tip: Make the most of wishlists</p>' +
            '    <p class="wl-ov-tip-text">Create lists for different projects or themes to keep your ideas organised.</p>' +
            '  </div>' +
            (learnMore
                ? '  <a class="wl-ov-tip-link" href="' + escHtml(learnMore) + '">Learn more <span aria-hidden="true">&rarr;</span></a>'
                : '') +
            '</div>';

        root.innerHTML =
            // renderStashHeader() serves double duty: the guest banner for
            // logged-out visitors, the stash bar for everyone else. Only the
            // latter is switched off.
            (SHOW_STASH_HEADER || !IS_LOGGED_IN ? renderStashHeader() : '') +
            '<header class="wl-ov-head">' +
            '  <div class="wl-ov-head-copy">' +
            '    <h1 class="wl-ov-title">Your wishlists</h1>' +
            '    <div class="wl-ov-rule" aria-hidden="true"></div>' +
            '    <p class="wl-ov-head-sub">Save future builds, organise projects and keep everything you want in one place.</p>' +
            '  </div>' +
            '  <button type="button" class="wl-ov-create" data-action="open-create-modal">' +
            WL_OV_ICONS.plus + 'Create new list</button>' +
            '</header>' +
            renderOverviewBenefits(learnMore) +
            '<div class="wl-ov-bar">' +
            '  <h2 class="wl-ov-bar-title">Your wishlists <span>(' + lists.length + ')</span></h2>' +
            '  <div class="wl-ov-sort"><span class="wl-ov-sort-label">Sort by</span>' + sortHtml + '</div>' +
            '</div>' +
            '<ul class="wl-ov-lists">' + rows + '</ul>' +
            tip +
            '<section class="wl-tr" data-wl-trending></section>';

        hydrateOverviewThumbs(root);
        loadOverviewPrices(root);
        loadTrendingSection(root);
    }

    // Only the first five items of each list are fetched for thumbnails, so
    // the rest have no live price until we ask. Done after first paint —
    // the plain total is already on screen and simply gains its RRP when
    // the answers land.
    var WL_OV_PRICE_FETCH_CAP = 200;

    function loadOverviewPrices(root) {
        var lists = state.wishlists || [];
        var handles = [];
        var seen = {};
        for (var i = 0; i < lists.length; i++) {
            var items = lists[i].items || [];
            for (var j = 0; j < items.length; j++) {
                var h = items[j].productHandle;
                if (h && !seen[h] && !productCache[h]) { seen[h] = true; handles.push(h); }
            }
        }
        if (!handles.length) { paintOverviewTotals(root); return; }

        // A 300-item stash should not fire 300 requests on page load. Any
        // list left incomplete keeps its plain total, which is correct
        // rather than merely quiet.
        handles = handles.slice(0, WL_OV_PRICE_FETCH_CAP);

        // fetchProductInfo resolves null instead of rejecting, so one dead
        // product cannot take the whole pass down.
        Promise.all(handles.map(function (h) { return fetchProductInfo(h); }))
            .then(function () { paintOverviewTotals(root); })
            .catch(function () {});
    }

    function paintOverviewTotals(root) {
        if (!root.isConnected) return;
        var nodes = root.querySelectorAll('[data-wl-total-for]');
        for (var i = 0; i < nodes.length; i++) {
            var id = nodes[i].getAttribute('data-wl-total-for');
            var wl = null;
            var lists = state.wishlists || [];
            for (var j = 0; j < lists.length; j++) {
                if (String(lists[j].id) === String(id)) { wl = lists[j]; break; }
            }
            if (wl) nodes[i].innerHTML = overviewTotalHtml(wl);
        }
    }

    function getCurrentListId() {
        try {
            return new URLSearchParams(window.location.search).get('list');
        } catch (e) { return null; }
    }

    function getCurrentShareToken() {
        try { return new URLSearchParams(window.location.search).get('share'); }
        catch (e) { return null; }
    }

    function loadSharedWishlist(token) {
        sharedLoading = true;
        return fetch(PROXY_BASE + '/api/share/' + encodeURIComponent(token))
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
                sharedWishlist = (data && data.wishlist) || null;
                return sharedWishlist;
            })
            .catch(function () {
                sharedWishlist = null;
                return null;
            })
            .finally(function () {
                sharedLoading = false;
            });
    }

    function renderItemsGridReadOnly(wl) {
        var items = wl.items || [];
        if (!items.length) {
            return '<p class="wl-detail-empty">This list is empty.</p>';
        }
        var viewMode = (wlConfig && wlConfig.wishlistView) || 'list';
        if (viewMode !== 'list' && viewMode !== 'grid' && viewMode !== 'compact') viewMode = 'list';
        var html = '<div class="wl-detail-grid wl-detail-grid--' + viewMode + '">';
        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            html +=
                '<article class="wl-detail-item" data-product-id="' + escHtml(it.shopifyProductId) + '" data-variant-id="' + escHtml(it.shopifyVariantId || '') + '" data-handle="' + escHtml(it.productHandle || '') + '">' +
                '  <div class="wl-detail-item-badge-slot" data-badge-slot></div>' +
                '  <div class="wl-detail-item-thumb"></div>' +
                '  <div class="wl-detail-item-body">' +
                '    <p class="wl-detail-item-title"><a href="/products/' + escHtml(it.productHandle || '') + '">' + escHtml(it.productHandle || 'Product') + '</a></p>' +
                '    <p class="wl-detail-item-vendor" data-vendor-slot></p>' +
                '    <p class="wl-detail-item-price">' + formatMoney(parseFloat(it.priceAtAdd || 0)) + '</p>' +
                '  </div>' +
                (wlConfig.showMoveToCart !== false ? '  <button type="button" class="wl-detail-item-move" data-wl-move-to-cart data-wishlist-id="' + escHtml(wl.id) + '" data-product-id="' + escHtml(it.shopifyProductId) + '" data-variant-id="' + escHtml(it.shopifyVariantId || '') + '" data-handle="' + escHtml(it.productHandle || '') + '"' + moveBtnStyle() + '>' + escHtml(langStr('moveToCartText', 'Move to basket')) + '</button>' : '') +
                '</article>';
        }
        html += '</div>';
        return html;
    }

    function renderSharedView(root) {
        if (sharedLoading) {
            root.innerHTML = '<div class="wl-detail-empty">Loading shared list…</div>';
            return;
        }
        if (!sharedWishlist) {
            root.innerHTML =
                '<div class="wl-detail-notfound">' +
                '  <a class="wl-detail-back" href="/pages/wishlist">&larr; Back to my wishlists</a>' +
                '  <h2>Shared list not found</h2>' +
                '  <p>This share link is no longer valid.</p>' +
                '</div>';
            return;
        }
        var wl = sharedWishlist;
        var items = wl.items || [];
        var totalCost = 0;
        for (var k = 0; k < items.length; k++) totalCost += parseFloat(items[k].priceAtAdd || 0);
        var lastUpdated = wl.updatedAt || wl.createdAt;
        var lastUpdatedLabel = lastUpdated ? formatDate(lastUpdated) : '';

        var html =
            '<a class="wl-detail-back" href="/pages/wishlist">&larr; Back to my wishlists</a>' +
            '<div class="wl-detail-card">' +
            '  <div class="wl-detail-head">' +
            '    <span class="wl-shared-badge">Shared with you</span>' +
            '    <h2 class="wl-detail-title">' + escHtml(wl.name) + ' <span class="wl-detail-count">(' + items.length + ')</span></h2>' +
            '    <p class="wl-detail-sub">Last updated: ' + escHtml(lastUpdatedLabel) + '</p>' +
            '    <p class="wl-detail-cost"><strong>List total:</strong> ' + formatMoney(totalCost) + '</p>' +
            '  </div>' +
            '  <div class="wl-detail-actions">' +
            '    <button type="button" class="wl-detail-add-all" data-wl-add-all data-wishlist-id="' + escHtml(wl.id) + '">Add all to Bag</button>' +
            '  </div>' +
            '</div>' +
            '<div class="wl-detail-items">' + renderItemsGridReadOnly(wl) + '</div>';
        root.innerHTML = html;
        hydrateDetailItems(root, wl);
    }

    // Once per page load, not once per render: renderGroupsBlocks runs again
    // on every filter, sort and toggle, and counting those as views would be
    // worse than counting none.
    var _viewTracked = false;

    function trackWishlistView() {
        if (_viewTracked) return;
        _viewTracked = true;
        // Fire and forget — a metric must never delay or break the page.
        try { apiGet('api/track/view').catch(function () {}); } catch (e) {}
    }

    function trackCartAdd(productId) {
        try {
            apiGet('api/track/cart-add' + (productId ? '?product_id=' + encodeURIComponent(productId) : ''))
                .catch(function () {});
        } catch (e) {}
    }

    function renderGroupsBlocks() {
        var blocks = document.querySelectorAll('[data-wl-groups]');
        if (!blocks.length) return;

        trackWishlistView();

        var listId = getCurrentListId();
        var shareToken = getCurrentShareToken();
        var inShareView = !!shareToken;
        var inDetail = !inShareView && listId !== null && listId !== '';

        if (inShareView) {
            var currentToken = getCurrentShareToken();
            if (!sharedWishlist && !sharedLoading && currentToken) {
                loadSharedWishlist(currentToken).finally(function () {
                    renderGroupsBlocks();
                });
            }
        }

        blocks.forEach(function (root) {
            if (inShareView) {
                renderSharedView(root);
                return;
            }
            if (state.wishlists.length === 0) {
                renderEmptyState(root);
                return;
            }
            if (inDetail) {
                var wl = state.wishlists.filter(function (w) {
                    return String(w.id) === String(listId);
                })[0];
                renderDetailView(root, wl);
                return;
            }
            renderOverview(root);
        });
    }

    async function addAllToCart(wishlistId) {
        var wl = state.wishlists.filter(function (w) { return String(w.id) === String(wishlistId); })[0];
        if (!wl && sharedWishlist && String(sharedWishlist.id) === String(wishlistId)) {
            wl = sharedWishlist;
        }
        if (!wl || !wl.items.length) return;
        var ids = await prepareCartItems(wl.items.map(function (it) { return { id: it.shopifyVariantId, handle: it.productHandle, quantity: 1 }; }), true);
        if (!ids) return;
        if (!ids.length) return showToast('No variants available');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids })
        })
        .then(function (r) {
            if (r.ok) return r.json();
            return r.json().then(function (err) {
                console.error('[WL] cart/add.js error', r.status, err);
                var msg = (err && (err.description || err.message)) || ('Status ' + r.status);
                return Promise.reject(new Error(msg));
            });
        })
        .then(function () {
            wl.items.forEach(function (it) {
                if (it.shopifyVariantId) trackCartAdd(it.shopifyProductId);
            });
            if (wlConfig.cartNotifPopup !== false) {
                showToast(langStr('msgAddedToCart', 'Item added to your basket.'));
            }
            if (window.Shopify && typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate();
        })
        .catch(function (err) {
            console.error('[WL] addAllToCart failed', err);
            showToast(err && err.message ? ('Could not add: ' + err.message) : 'Failed to add to basket');
        });
    }

    async function moveItemToCart(wishlistId, productId, variantId, handle, quantity) {
        if (!variantId) {
            showToast('This item has no variant. Open the product to choose options.');
            return;
        }
        var qty = parseInt(quantity, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        var cartItems = await prepareCartItems([{ id: variantId, handle: handle, quantity: qty }], false);
        if (!cartItems) return;
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: cartItems })
        })
        .then(function (r) {
            if (r.ok) return r.json();
            return r.json().then(function (err) {
                console.error('[WL] cart/add.js error', r.status, err);
                var msg = (err && (err.description || err.message)) || ('Status ' + r.status);
                return Promise.reject(new Error(msg));
            });
        })
        .then(function () {
            trackCartAdd(String(productId || ''));
            if (wlConfig.cartNotifPopup !== false) {
                showToast(langStr('msgAddedToCart', 'Item added to your basket.'));
            }
            if (wlConfig.removeAfterCart !== false) {
                return apiPost('api/wishlists/remove', { wishlistId: wishlistId, shopifyProductId: String(productId) });
            }
            return Promise.resolve();
        })
        .then(function () { return loadWishlists(); })
        .catch(function (err) {
            console.error('[WL] moveItemToCart failed', err);
            showToast(err && err.message ? ('Could not move: ' + err.message) : 'Failed to move to basket');
        });
    }

    function wireRecommendedCarousel() {
        document.querySelectorAll('[data-wl-recommended-track]').forEach(function (track) {
            var list = track.querySelector('[data-wl-rec-list]');
            var prev = track.querySelector('[data-wl-rec-prev]');
            var next = track.querySelector('[data-wl-rec-next]');
            if (!list || !prev || !next) return;

            if (list.children.length === 0) {
                prev.style.display = 'none';
                next.style.display = 'none';
                return;
            }

            prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.8, behavior: 'smooth' }); });
            next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' }); });
        });
    }

    // ─── Trending wishlist widget ─────────────────────────────────────────────
    function renderTrendingWidget() {
        var blocks = document.querySelectorAll('[data-wl-trending]');
        if (blocks.length === 0) return;
        if (!wlConfig || wlConfig.showTrendingWidget !== true) {
            // App-level toggle off — hide every block
            blocks.forEach(function (b) { b.style.display = 'none'; });
            return;
        }

        var firstBlock = blocks[0];
        var limit = Math.min(50, Math.max(4, parseInt(firstBlock.getAttribute('data-limit') || '12', 10)));
        var heading = (wlConfig.trendingHeading || 'Trending wishlist items');
        var layout = wlConfig.trendingLayout || 'slider';
        var showArrows = wlConfig.trendingSliderShowArrows !== false;
        var autoRotate = wlConfig.trendingSliderAutoRotate === true;
        var desktopCols = Math.min(6, Math.max(1, parseInt(wlConfig.trendingDesktopCols, 10) || 3));
        var mobileCols = Math.min(3, Math.max(1, parseInt(wlConfig.trendingMobileCols, 10) || 1));

        fetch(PROXY_BASE + '/api/wishlists/trending?limit=' + limit, { credentials: 'include' })
            .then(function (r) { return r.ok ? r.json() : { handles: [] }; })
            .then(function (data) {
                var handles = (data && data.handles) || [];
                if (handles.length === 0) {
                    blocks.forEach(function (b) { b.style.display = 'none'; });
                    return;
                }
                return Promise.all(handles.map(function (h) {
                    return fetch('/products/' + h + '.js')
                        .then(function (r) { return r.ok ? r.json() : null; })
                        .catch(function () { return null; });
                })).then(function (products) {
                    return products.filter(function (p) { return p && p.id; });
                });
            })
            .then(function (products) {
                if (!products || products.length === 0) return;
                blocks.forEach(function (block) {
                    paintTrendingBlock(block, products, {
                        heading: heading,
                        layout: layout,
                        showArrows: showArrows,
                        autoRotate: autoRotate,
                        desktopCols: desktopCols,
                        mobileCols: mobileCols,
                    });
                });
            })
            .catch(function () {});
    }

    function paintTrendingBlock(block, products, opts) {
        var cards = products.map(function (p) {
            var img = p.featured_image
                ? '<img class="wl-trending-img" src="' + escHtml(p.featured_image) + '" alt="' + escHtml(p.title || '') + '" loading="lazy" />'
                : '<div class="wl-trending-img-placeholder"></div>';
            var price = typeof p.price === 'number'
                ? formatMoney(p.price / 100)
                : (p.price || '');
            return '<a class="wl-trending-card" href="/products/' + escHtml(p.handle) + '">' +
                img +
                '<div class="wl-trending-card-body">' +
                '  <p class="wl-trending-card-title">' + escHtml(p.title || '') + '</p>' +
                '  <p class="wl-trending-card-price">' + price + '</p>' +
                '</div>' +
                '</a>';
        }).join('');

        var html =
            '<h2 class="wl-trending-heading">' + escHtml(opts.heading) + '</h2>' +
            '<div class="wl-trending-track" data-wl-trending-track data-layout="' + opts.layout + '" style="--wl-trending-cols-desktop:' + opts.desktopCols + ';--wl-trending-cols-mobile:' + opts.mobileCols + ';">' +
            (opts.layout === 'slider' && opts.showArrows ? '<button type="button" class="wl-trending-arrow wl-trending-arrow--prev" aria-label="Previous" data-wl-trending-prev>&#8249;</button>' : '') +
            '<div class="wl-trending-list" data-wl-trending-list>' + cards + '</div>' +
            (opts.layout === 'slider' && opts.showArrows ? '<button type="button" class="wl-trending-arrow wl-trending-arrow--next" aria-label="Next" data-wl-trending-next>&#8250;</button>' : '') +
            '</div>';

        block.innerHTML = html;
        block.classList.toggle('wl-trending--slider', opts.layout === 'slider');
        block.classList.toggle('wl-trending--grid', opts.layout === 'grid');

        var list = block.querySelector('[data-wl-trending-list]');
        var prev = block.querySelector('[data-wl-trending-prev]');
        var next = block.querySelector('[data-wl-trending-next]');
        if (opts.layout === 'slider' && list) {
            if (prev) prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.8, behavior: 'smooth' }); });
            if (next) next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' }); });
            if (opts.autoRotate) startTrendingAutoRotate(list);
        }
    }

    var _trendingAutoRotateTimers = [];
    function startTrendingAutoRotate(list) {
        var step = function () {
            if (!list.isConnected) return;
            var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
            if (atEnd) {
                list.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' });
            }
        };
        var id = setInterval(step, 4500);
        _trendingAutoRotateTimers.push(id);
    }

    function loadWishlists() {
        if (state.loading) return;
        if (!IS_LOGGED_IN && !state.guestToken) {
            updateHeartButtons();
            // Nothing to fetch — but the page still has to say so. Returning
            // here without rendering left a first-time visitor looking at
            // "Loading…" indefinitely.
            renderGroupsBlocks();
            return;
        }
        state.loading = true;
        return apiGet('api/wishlists')
            .then(function (data) {
                state.wishlists = data.wishlists || [];
                if (data.stashProfile) stashProfile = data.stashProfile;
            })
            .catch(function (e) {
                console.error('[WL] loadWishlists error', e);
                state.wishlists = [];
            })
            .finally(function () {
                state.loading = false;
                enhanceHeaderHearts();
                updateHeartButtons();
                updateBadge();
                renderGroupsBlocks();
            });
    }

    function addToWishlist(wishlistId, productId, variantId, handle, price, sku) {
        if (!productId || !wishlistId) return Promise.reject(new Error('Missing wishlistId or productId'));

        var effectiveVariantId = wlConfig.variantDetection === false ? '' : String(variantId || '');
        return apiPost('api/wishlists/add', {
            wishlistId: wishlistId,
            shopifyProductId: String(productId),
            shopifyVariantId: effectiveVariantId,
            productHandle: String(handle || ''),
            sku: String(sku || ''),
            price: parseFloat(price) || 0,
        }).then(function (result) {
            trackPixel('AddToWishlist', {
                content_ids: [String(productId)],
                content_type: 'product',
                value: parseFloat(price) || 0,
                currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
            });
            return result;
        });
    }

    function removeFromWishlist(wishlistId, productId) {
        if (!productId || !wishlistId) return Promise.reject(new Error('Missing wishlistId or productId'));

        return apiPost('api/wishlists/remove', {
            wishlistId: wishlistId,
            shopifyProductId: String(productId),
        });
    }

    function navigateInPage(href) {
        try {
            if (window.location.pathname + window.location.search === href) {
                return;
            }
            history.pushState(null, '', href);
            renderGroupsBlocks();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
            window.location.href = href;
        }
    }

    // Sort is re-rendered rather than reordered in place: the rows carry
    // hydrated thumbnails, and fetchProductInfo caches, so a re-render is
    // cheap and avoids keeping DOM and state in sync by hand.
    document.addEventListener('change', function (e) {
        var sortEl = e.target.closest && e.target.closest('[data-wl-sort]');
        if (sortEl) {
            _ovSort = sortEl.value;
            renderGroupsBlocks();
            return;
        }

        var dtSortEl = e.target.closest && e.target.closest('[data-wl-detail-sort]');
        if (dtSortEl) {
            _dtSort = dtSortEl.value;
            repaintDetail();
        }
    });

    // Repaint rather than re-render: the hero and its collage do not depend on
    // the filter, and rebuilding them would refetch images and lose focus from
    // the search box mid-typing.
    function repaintDetail() {
        var roots = document.querySelectorAll('[data-wl-groups]');
        for (var i = 0; i < roots.length; i++) {
            var body = roots[i].querySelector('[data-wl-detail-body]');
            if (!body) continue;
            var listId = getCurrentListId();
            var wl = state.wishlists.filter(function (w) { return String(w.id) === String(listId); })[0];
            if (wl) paintDetailBody(roots[i], wl);
        }
    }

    var _dtSearchTimer = null;
    document.addEventListener('input', function (e) {
        var searchEl = e.target.closest && e.target.closest('[data-wl-detail-search]');
        if (!searchEl) return;
        _dtSearch = searchEl.value || '';
        if (_dtSearchTimer) clearTimeout(_dtSearchTimer);
        // Debounced so a repaint doesn't fire on every keystroke; focus and
        // caret are restored afterwards because the input is rebuilt.
        _dtSearchTimer = setTimeout(function () {
            repaintDetail();
            var again = document.querySelector('[data-wl-detail-search]');
            if (again) {
                again.focus();
                try { again.setSelectionRange(again.value.length, again.value.length); } catch (err) {}
            }
        }, 220);
    });

    function closeOverviewMenus(except) {
        var pops = document.querySelectorAll('.wl-ov-menu-pop');
        for (var i = 0; i < pops.length; i++) {
            if (pops[i] === except) continue;
            pops[i].hidden = true;
            var btn = pops[i].parentNode && pops[i].parentNode.querySelector('[data-wl-menu-btn]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
        }
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeOverviewMenus(null);
    });

    // --- Wishlist Groups click delegation ---
    document.addEventListener('click', function (e) {
        var alertBtn = e.target.closest && e.target.closest('[data-wl-alert-toggle]');
        if (alertBtn) {
            e.preventDefault();
            var field = alertBtn.getAttribute('data-wl-alert-toggle');
            var alertWlId = parseInt(alertBtn.getAttribute('data-wishlist-id'), 10);
            var wlRow = state.wishlists.filter(function (w) { return w.id === alertWlId; })[0];
            if (!wlRow) return;

            // Nothing to apply the preference to, and nothing to store it on.
            if (!(wlRow.items || []).length) return;

            var next = !alertStateFor(wlRow, field);
            var payload = { wishlistId: alertWlId };
            payload[field] = next;

            // Optimistic: the flag only affects future alerts, so a failed write
            // costs nothing that a reload will not correct.
            (wlRow.items || []).forEach(function (it) { it[field] = next; });
            alertBtn.classList.toggle('is-off', !next);
            alertBtn.setAttribute('aria-checked', String(next));

            apiPost('api/wishlists/notifications', payload).catch(function () {});
            return;
        }

        var chip = e.target.closest && e.target.closest('[data-wl-filter]');
        if (chip) {
            e.preventDefault();
            _dtFilter = chip.getAttribute('data-wl-filter') || 'all';
            repaintDetail();
            return;
        }

        // "Move to another list" reuses the same picker the heart opens, so a
        // list gained here shows the tick straight away.
        var moveList = e.target.closest && e.target.closest('[data-wl-move-list]');
        if (moveList) {
            e.preventDefault();
            e.stopPropagation();
            var row = moveList.closest('.wl-dt-row');
            openListPicker({
                productId: moveList.getAttribute('data-product-id'),
                variantId: row ? row.getAttribute('data-variant-id') : '',
                handle: moveList.getAttribute('data-handle'),
                price: '',
                sku: ''
            }, moveList);
            return;
        }

        var menuBtn = e.target.closest && e.target.closest('[data-wl-menu-btn]');
        if (menuBtn) {
            e.preventDefault();
            e.stopPropagation();
            var pop = menuBtn.parentNode.querySelector('.wl-ov-menu-pop');
            var willOpen = pop.hidden;
            closeOverviewMenus(pop);
            pop.hidden = !willOpen;
            menuBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            return;
        }
        // Any other click closes an open menu, including a click on one of its
        // own items — those re-render the list anyway.
        if (!e.target.closest || !e.target.closest('.wl-ov-menu-pop')) {
            closeOverviewMenus(null);
        }

        // Whole item card navigates to the PDP. Previously only the title anchor
        // did, so clicking the thumbnail or price — the obvious targets — did
        // nothing. Controls inside the card keep their own behaviour.
        // Deliberately not '.wl-dt-row': the rebuilt rows carry explicit links,
        // so a clickable background would only hijack stray clicks.
        var itemCard = e.target.closest && e.target.closest('.wl-detail-item');
        if (itemCard && !e.target.closest('a, button, input, label, select, [data-qty-slot], [data-variant-slot]')) {
            var itemHandle = itemCard.getAttribute('data-handle');
            if (itemHandle) {
                window.location.href = '/products/' + itemHandle;
                return;
            }
        }

        // Intercept clicks on overview list cards (.wl-card-link) — navigate to detail
        var cardLink = e.target.closest('a.wl-card-link');
        if (cardLink) {
            var actionInside = e.target.closest('[data-wl-add-all], [data-wl-edit-list], [data-wl-share-list], [data-wl-delete-list]');
            if (actionInside) {
                e.preventDefault();
            } else {
                var href = cardLink.getAttribute('href');
                if (href && href.indexOf('/pages/wishlist') === 0) {
                    e.preventDefault();
                    navigateInPage(href);
                }
                return;
            }
        }

        // Intercept clicks on the back link (.wl-detail-back) — navigate to overview
        var backLink = e.target.closest('a.wl-detail-back');
        if (backLink) {
            var backHref = backLink.getAttribute('href');
            if (backHref && backHref.indexOf('/pages/wishlist') === 0) {
                e.preventDefault();
                navigateInPage(backHref);
            }
            return;
        }

        var addAll = e.target.closest('[data-wl-add-all]');
        if (addAll) {
            e.preventDefault();
            e.stopPropagation();
            addAllToCart(parseInt(addAll.getAttribute('data-wishlist-id'), 10));
            return;
        }

        var moveBtn = e.target.closest('[data-wl-move-to-cart]');
        if (moveBtn) {
            e.preventDefault();
            e.stopPropagation();
            var moveCard = moveBtn.closest('.wl-dt-row, .wl-detail-item');
            var moveVariantId = moveCard ? (moveCard.getAttribute('data-variant-id') || moveBtn.getAttribute('data-variant-id')) : moveBtn.getAttribute('data-variant-id');
            var moveQty = moveCard ? parseInt(moveCard.getAttribute('data-qty') || '1', 10) : 1;
            moveItemToCart(
                parseInt(moveBtn.getAttribute('data-wishlist-id'), 10),
                moveBtn.getAttribute('data-product-id'),
                moveVariantId,
                moveBtn.getAttribute('data-handle'),
                moveQty
            );
            return;
        }

        // ─── Quantity stepper ─────────────────────────────────────────────────
        var qtyDec = e.target.closest('[data-wl-qty-dec]');
        if (qtyDec) {
            e.preventDefault();
            e.stopPropagation();
            adjustItemQty(qtyDec.closest('.wl-dt-row, .wl-detail-item'), -1);
            return;
        }
        var qtyInc = e.target.closest('[data-wl-qty-inc]');
        if (qtyInc) {
            e.preventDefault();
            e.stopPropagation();
            adjustItemQty(qtyInc.closest('.wl-dt-row, .wl-detail-item'), +1);
            return;
        }

        // ─── Bulk actions ─────────────────────────────────────────────────────
        var bulkAddBtn = e.target.closest('[data-wl-bulk-add-selected]');
        if (bulkAddBtn) {
            e.preventDefault();
            e.stopPropagation();
            addSelectedToCart(parseInt(bulkAddBtn.getAttribute('data-wishlist-id'), 10));
            return;
        }
        var bulkRemoveBtn = e.target.closest('[data-wl-bulk-remove-selected]');
        if (bulkRemoveBtn) {
            e.preventDefault();
            e.stopPropagation();
            removeSelectedFromWishlist(parseInt(bulkRemoveBtn.getAttribute('data-wishlist-id'), 10));
            return;
        }

        var removeBtn = e.target.closest('[data-wl-remove-item]');
        if (removeBtn) {
            e.preventDefault();
            e.stopPropagation();
            var wishlistId = parseInt(removeBtn.getAttribute('data-wishlist-id'), 10);
            var productId = removeBtn.getAttribute('data-product-id');
            removeFromWishlist(wishlistId, productId)
                .then(function () { return loadWishlists(); })
                .catch(function (err) { showToast(err && err.message ? err.message : 'Failed to remove item'); });
            return;
        }

        var editBtn = e.target.closest('[data-wl-edit-list]');
        if (editBtn) {
            e.preventDefault();
            e.stopPropagation();
            openEditModal(
                editBtn.getAttribute('data-wishlist-id'),
                editBtn.getAttribute('data-wishlist-name')
            );
            return;
        }

        var shareBtn = e.target.closest('[data-wl-share-list]');
        if (shareBtn) {
            e.preventDefault();
            e.stopPropagation();
            shareWishlist(shareBtn.getAttribute('data-wishlist-id'));
            return;
        }

        var deleteBtn = e.target.closest('[data-wl-delete-list]');
        if (deleteBtn) {
            e.preventDefault();
            e.stopPropagation();
            deleteWishlist(deleteBtn.getAttribute('data-wishlist-id'));
            return;
        }
    });

    // ─── Variant select + bulk checkbox change handler ──────────────────────
    document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;

        if (t.matches && t.matches('[data-wl-variant-select]')) {
            var card = t.closest('.wl-dt-row, .wl-detail-item');
            if (card) card.setAttribute('data-variant-id', t.value);
            return;
        }

        if (t.matches && t.matches('[data-wl-item-checkbox]')) {
            updateBulkToolbarState();
            return;
        }

        if (t.matches && t.matches('[data-wl-bulk-select-all]')) {
            var toolbar = t.closest('[data-wl-bulk-toolbar]');
            var grid = toolbar ? toolbar.nextElementSibling : null;
            if (grid) {
                grid.querySelectorAll('[data-wl-item-checkbox]').forEach(function (cb) { cb.checked = t.checked; });
                updateBulkToolbarState();
            }
            return;
        }
    });

    function adjustItemQty(card, delta) {
        if (!card) return;
        var input = card.querySelector('[data-wl-qty-input]');
        if (!input) return;
        var cur = parseInt(input.value || '1', 10);
        if (isNaN(cur)) cur = 1;
        var next = Math.max(1, Math.min(99, cur + delta));
        input.value = String(next);
        card.setAttribute('data-qty', String(next));
    }

    function getSelectedCards() {
        var toolbar = document.querySelector('[data-wl-bulk-toolbar]');
        if (!toolbar) return [];
        var grid = toolbar.nextElementSibling;
        if (!grid) return [];
        return Array.from(grid.querySelectorAll('.wl-dt-row, .wl-detail-item')).filter(function (card) {
            var cb = card.querySelector('[data-wl-item-checkbox]');
            return cb && cb.checked;
        });
    }

    function updateBulkToolbarState() {
        var toolbar = document.querySelector('[data-wl-bulk-toolbar]');
        if (!toolbar) return;
        var grid = toolbar.nextElementSibling;
        if (!grid) return;
        var checkboxes = grid.querySelectorAll('[data-wl-item-checkbox]');
        var selected = Array.from(checkboxes).filter(function (cb) { return cb.checked; });
        var label = toolbar.querySelector('[data-wl-bulk-selected-label]');
        if (label) label.textContent = selected.length + ' selected';
        var addBtn = toolbar.querySelector('[data-wl-bulk-add-selected]');
        var rmBtn = toolbar.querySelector('[data-wl-bulk-remove-selected]');
        if (addBtn) addBtn.disabled = selected.length === 0;
        if (rmBtn) rmBtn.disabled = selected.length === 0;
        var selAll = toolbar.querySelector('[data-wl-bulk-select-all]');
        if (selAll && checkboxes.length > 0) {
            selAll.checked = selected.length === checkboxes.length;
            selAll.indeterminate = selected.length > 0 && selected.length < checkboxes.length;
        }
    }

    async function addSelectedToCart(wishlistId) {
        var cards = getSelectedCards();
        if (cards.length === 0) return;
        var items = await prepareCartItems(cards.map(function (card) {
            var variantId = card.getAttribute('data-variant-id');
            var qty = parseInt(card.getAttribute('data-qty') || '1', 10);
            return { id: variantId, handle: card.getAttribute('data-handle'), quantity: qty };
        }), false);
        if (!items) return;
        if (items.length === 0) return showToast('No variants available for selected items');

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
            .then(function (r) {
                if (r.ok) return r.json();
                return r.json().then(function (err) {
                    var msg = (err && (err.description || err.message)) || ('Status ' + r.status);
                    return Promise.reject(new Error(msg));
                });
            })
            .then(function () {
                if (wlConfig.cartNotifPopup !== false) showToast(langStr('msgAddedToCart', 'Item added to your basket.'));
                if (window.Shopify && typeof Shopify.onCartUpdate === 'function') Shopify.onCartUpdate();
                if (wlConfig.removeAfterCart !== false) {
                    return Promise.all(cards.map(function (card) {
                        return apiPost('api/wishlists/remove', {
                            wishlistId: wishlistId,
                            shopifyProductId: String(card.getAttribute('data-product-id')),
                        });
                    })).then(function () { loadWishlists(); });
                }
            })
            .catch(function (err) {
                showToast(err && err.message ? ('Could not add: ' + err.message) : 'Failed to add to basket');
            });
    }

    function removeSelectedFromWishlist(wishlistId) {
        var cards = getSelectedCards();
        if (cards.length === 0) return;
        showConfirmDialog({
            title: 'Remove selected items?',
            message: 'Remove ' + cards.length + ' item(s) from this wishlist?',
            confirmLabel: 'Remove',
            danger: true,
        }).then(function (ok) {
            if (!ok) return;
            Promise.all(cards.map(function (card) {
                return apiPost('api/wishlists/remove', {
                    wishlistId: wishlistId,
                    shopifyProductId: String(card.getAttribute('data-product-id')),
                });
            }))
                .then(function () {
                    if (wlConfig.wishlistNotifPopup !== false) showToast(langStr('msgRemoved', 'Item has been successfully removed from your wishlist'));
                    return loadWishlists();
                })
                .catch(function (err) {
                    showToast(err && err.message ? err.message : 'Failed to remove selected items');
                });
        });
    }

    // --- List Picker ---
    var pickerProduct = null;
    var _pickerOutsideHandler = null;
    var _pickerEscHandler = null;

    function getPickerEl() { return document.getElementById('wl-list-picker'); }

    function renderPickerItems() {
        var picker = getPickerEl();
        if (!picker) return;
        var ul = picker.querySelector('.wl-list-picker-items');
        if (!ul) return;

        ul.innerHTML = '';
        state.wishlists.forEach(function (wl) {
            var checked = pickerProduct ? isProductInList(wl.id, pickerProduct.productId) : false;
            var count = (wl.items || []).length;
            var li = document.createElement('li');
            li.setAttribute('data-wishlist-id', String(wl.id));

            var cbId = 'wl-pick-' + wl.id;
            var cb = document.createElement('input');
            cb.type = 'checkbox';
            cb.id = cbId;
            cb.checked = checked;

            var lbl = document.createElement('label');
            lbl.htmlFor = cbId;
            lbl.innerHTML = escHtml(wl.name || 'Wishlist') + ' <span class="wl-list-count">(' + count + ')</span>';

            li.appendChild(cb);
            li.appendChild(lbl);
            ul.appendChild(li);
        });
    }

    function positionPicker(anchorEl) {
        var picker = getPickerEl();
        if (!picker || !anchorEl) return;

        var rect = anchorEl.getBoundingClientRect();
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var scrollX = window.pageXOffset || document.documentElement.scrollLeft;
        var viewportWidth = window.innerWidth;
        var pickerWidth = picker.offsetWidth || 240;

        var desiredLeft = rect.left + scrollX;
        if (desiredLeft + pickerWidth > scrollX + viewportWidth - 12) {
            desiredLeft = rect.right + scrollX - pickerWidth;
        }
        desiredLeft = Math.max(scrollX + 12, Math.min(desiredLeft, scrollX + viewportWidth - pickerWidth - 12));
        picker.style.left = desiredLeft + 'px';

        var spaceBelow = window.innerHeight - rect.bottom;
        var pickerHeight = picker.offsetHeight || 280;

        if (spaceBelow < pickerHeight && rect.top > pickerHeight) {
            picker.style.top = (rect.top + scrollY - pickerHeight - 4) + 'px';
        } else {
            picker.style.top = (rect.bottom + scrollY + 4) + 'px';
        }
    }

    function openListPicker(productMeta, anchorEl) {
        if (!productMeta) return;

        if (state.wishlists.length === 0) {
            openCreateModal(productMeta);
            return;
        }

        pickerProduct = productMeta;

        var picker = getPickerEl();
        if (!picker) return;

        renderPickerItems();
        picker.removeAttribute('hidden');
        positionPicker(anchorEl);

        _pickerEscHandler = function (e) {
            if (e.key === 'Escape') closeListPicker();
        };
        document.addEventListener('keydown', _pickerEscHandler);

        setTimeout(function () {
            _pickerOutsideHandler = function (e) {
                if (!picker.contains(e.target)) closeListPicker();
            };
            document.addEventListener('click', _pickerOutsideHandler);
        }, 0);
    }

    function closeListPicker() {
        var picker = getPickerEl();
        if (picker) picker.setAttribute('hidden', '');
        if (_pickerOutsideHandler) {
            document.removeEventListener('click', _pickerOutsideHandler);
            _pickerOutsideHandler = null;
        }
        if (_pickerEscHandler) {
            document.removeEventListener('keydown', _pickerEscHandler);
            _pickerEscHandler = null;
        }
        pickerProduct = null;
    }

    // Delegated checkbox change handler on the picker list
    var _pickerListEl = null;
    function getPickerListEl() {
        if (!_pickerListEl) {
            _pickerListEl = document.querySelector('.wl-list-picker-items');
        }
        return _pickerListEl;
    }

    document.addEventListener('change', function (e) {
        var cb = e.target;
        if (!cb || cb.type !== 'checkbox') return;
        var li = cb.closest('li[data-wishlist-id]');
        if (!li) return;
        var picker = getPickerEl();
        if (!picker || !picker.contains(li)) return;

        if (!pickerProduct) return;

        var wishlistId = parseInt(li.getAttribute('data-wishlist-id'), 10);
        var wl = null;
        for (var i = 0; i < state.wishlists.length; i++) {
            if (state.wishlists[i].id === wishlistId) { wl = state.wishlists[i]; break; }
        }
        var listName = wl ? (wl.name || 'wishlist') : 'wishlist';
        var isChecked = cb.checked;

        var promise;
        if (isChecked) {
            promise = addToWishlist(
                wishlistId,
                pickerProduct.productId,
                pickerProduct.variantId,
                pickerProduct.handle,
                pickerProduct.price,
                pickerProduct.sku
            );
        } else {
            promise = removeFromWishlist(wishlistId, pickerProduct.productId);
        }

        promise
            .then(function () {
                if (isChecked) {
                    var thumbUrl = '';
                    var info = pickerProduct && pickerProduct.handle ? productCache[pickerProduct.handle] : null;
                    if (info && info.featured_image) thumbUrl = info.featured_image;
                    if (wlConfig.wishlistNotifPopup !== false) {
                        if (IS_LOGGED_IN) {
                            showWishlistAddedToast(thumbUrl);
                        } else {
                            showToast(null, {
                                thumb: thumbUrl,
                                html: 'Item has been temporarily added to wishlist, please <a href="/account/login">login</a> to save it permanently'
                            });
                        }
                    }
                } else {
                    if (wlConfig.wishlistNotifPopup !== false) {
                        showToast(langStr('msgRemoved', 'Item has been successfully removed from your wishlist'));
                    }
                }
                return loadWishlists();
            })
            .then(function () {
                if (!getPickerEl().hasAttribute('hidden') && pickerProduct) {
                    var savedProduct = pickerProduct;
                    pickerProduct = savedProduct;
                    renderPickerItems();
                }
            })
            .catch(function (err) {
                console.error('[WL] picker change error', err);
                cb.checked = !isChecked;
                if (err && err.code === 'GUEST_ITEM_LIMIT') {
                    showSignupGate('GUEST_ITEM_LIMIT');
                    return;
                }
                if (err && err.code === 'GUEST_LIST_LIMIT') {
                    showSignupGate('GUEST_LIST_LIMIT');
                    return;
                }
                showToast(err && err.message ? err.message : 'Something went wrong — please try again');
            });
    });

    // --- List Management (edit / share / delete) ---
    var modalMode = 'create';
    var modalEditWishlistId = null;

    function openEditModal(wishlistId, currentName) {
        modalMode = 'edit';
        modalEditWishlistId = wishlistId;

        var modal = getModalEl();
        var overlay = getOverlayEl();
        if (!modal || !overlay) return;

        var titleEl = modal.querySelector('.wl-create-modal-header h3');
        var input = modal.querySelector('.wl-create-modal-input');
        var errEl = modal.querySelector('.wl-create-modal-error');
        var submitBtn = modal.querySelector('.wl-create-modal-submit');

        // Read the current description off state rather than the caller, so
        // every entry point into edit gets it without threading it through.
        var editing = state.wishlists.filter(function (w) {
            return String(w.id) === String(wishlistId);
        })[0];
        var editDesc = modal.querySelector('.wl-create-modal-textarea');
        var editCount = modal.querySelector('[data-wl-desc-count]');

        if (titleEl) titleEl.textContent = 'Edit list';
        if (input) input.value = currentName || '';
        if (editDesc) editDesc.value = (editing && editing.description) || '';
        if (editCount) editCount.textContent = ((editing && editing.description) || '').length + '/150';
        if (errEl) { errEl.textContent = ''; errEl.setAttribute('hidden', ''); }
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Save'; }

        overlay.removeAttribute('hidden');
        modal.removeAttribute('hidden');

        if (input) setTimeout(function () { input.focus(); }, 50);

        _modalEscHandler = function (e) {
            if (e.key === 'Escape') closeCreateModal();
        };
        document.addEventListener('keydown', _modalEscHandler);
    }

    // ─── Share modal ──────────────────────────────────────────────────────────

    function langStr(key, fallback) {
        return (wlConfig && wlConfig.lang && wlConfig.lang[key]) || fallback;
    }

    function showWishlistAddedToast(thumbUrl) {
        // Use the appropriate lang message — guest vs logged-in — and pass as HTML
        // since these strings include a markdown-ish <a> link.
        var msg = IS_LOGGED_IN
            ? langStr('msgLoggedSuccess', 'Item has been successfully added to wishlist')
            : langStr('msgGuestSuccess', 'Item has been temporarily added to wishlist');
        showToast('', { thumb: thumbUrl, html: msg });
    }

    function moveBtnStyle() {
        var bg = wlConfig && wlConfig.lang && wlConfig.lang.moveToCartBg;
        var col = wlConfig && wlConfig.lang && wlConfig.lang.moveToCartColor;
        if (!bg && !col) return '';
        var s = ' style="';
        if (bg) s += 'background:' + bg + ';';
        if (col) s += 'color:' + col + ';';
        s += '"';
        return s;
    }

    function copyToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text);
        }
        return new Promise(function (resolve, reject) {
            try {
                var ta = document.createElement('textarea');
                ta.value = text;
                ta.style.position = 'fixed';
                ta.style.opacity = '0';
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
                resolve();
            } catch (e) { reject(e); }
        });
    }

    var SHARE_CHIP_ICONS = {
        whatsapp: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.2h.01c5.46 0 9.91-4.45 9.91-9.91a9.82 9.82 0 0 0-2.91-7zM12.04 20.13h-.01a8.22 8.22 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.36c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.41a8.21 8.21 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.25 8.24zm4.52-6.16c-.25-.12-1.47-.72-1.69-.8-.23-.08-.39-.13-.56.12-.16.25-.64.8-.78.96-.14.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.39-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.55-.42-.14-.01-.31-.01-.47-.01-.16 0-.43.06-.65.31-.23.25-.85.83-.85 2.03 0 1.2.87 2.36.99 2.52.12.17 1.71 2.6 4.14 3.65.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z"/></svg>',
        email: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>',
        facebook: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"/></svg>',
        twitter: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
        copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>'
    };

    function buildShareChips(shareUrl, shareText) {
        var enc = encodeURIComponent;
        var chips = [];
        if (wlConfig && wlConfig.shareWhatsapp !== false) {
            chips.push({
                key: 'whatsapp',
                label: langStr('shareWhatsappTooltip', 'WhatsApp'),
                href: 'https://wa.me/?text=' + enc(shareText + ' ' + shareUrl)
            });
        }
        if (wlConfig && wlConfig.shareEmail !== false) {
            chips.push({
                key: 'email',
                label: langStr('shareEmailTooltip', 'Email'),
                href: 'mailto:?subject=' + enc(shareText) + '&body=' + enc(shareText + '\n\n' + shareUrl)
            });
        }
        if (wlConfig && wlConfig.shareFacebook !== false) {
            chips.push({
                key: 'facebook',
                label: langStr('shareFbTooltip', 'Share on facebook'),
                href: 'https://www.facebook.com/sharer/sharer.php?u=' + enc(shareUrl)
            });
        }
        if (wlConfig && wlConfig.shareTwitter !== false) {
            chips.push({
                key: 'twitter',
                label: langStr('shareTwitterTooltip', 'X / Twitter'),
                href: 'https://twitter.com/intent/tweet?text=' + enc(shareText) + '&url=' + enc(shareUrl)
            });
        }
        return chips;
    }

    function closeShareModal() {
        var modal = document.getElementById('wl-share-modal');
        var overlay = document.getElementById('wl-share-overlay');
        if (modal) modal.setAttribute('hidden', '');
        if (overlay) overlay.setAttribute('hidden', '');
        document.removeEventListener('keydown', _shareEscHandler);
    }

    var _shareEscHandler = function (e) { if (e.key === 'Escape') closeShareModal(); };

    function openShareModal(shareUrl) {
        var modal = document.getElementById('wl-share-modal');
        var overlay = document.getElementById('wl-share-overlay');
        if (!modal || !overlay) {
            // Fallback to clipboard copy if modal markup absent
            copyToClipboard(shareUrl).then(function () { showToast(langStr('msgUrlCopied', 'Wishlist url copied successfully!')); });
            return;
        }

        var input = modal.querySelector('[data-wl-share-url-input]');
        if (input) input.value = shareUrl;

        var chipsContainer = modal.querySelector('[data-wl-share-chips]');
        if (chipsContainer) {
            var shareText = langStr('pageShareText', 'Hey there! Check out My Wishlist');
            var chips = buildShareChips(shareUrl, shareText);
            chipsContainer.innerHTML = chips.map(function (c) {
                return '<a class="wl-share-chip wl-share-chip--' + c.key + '" href="' + c.href + '" target="_blank" rel="noopener noreferrer" title="' + c.label.replace(/"/g, '&quot;') + '">' +
                    '<span class="wl-share-chip-icon">' + SHARE_CHIP_ICONS[c.key] + '</span>' +
                    '<span class="wl-share-chip-label">' + c.label + '</span>' +
                    '</a>';
            }).join('');
        }

        overlay.removeAttribute('hidden');
        modal.removeAttribute('hidden');
        document.addEventListener('keydown', _shareEscHandler);

        // Reset copy button state
        var copyBtn = modal.querySelector('[data-action="copy-share-url"]');
        if (copyBtn) {
            copyBtn.classList.remove('is-copied');
            copyBtn.textContent = 'Copy';
        }
    }

    function shareWishlist(wishlistId) {
        if (wlConfig && wlConfig.shareWishlist === false) {
            return; // master share toggle off
        }
        apiPost('api/wishlists/share', { wishlistId: parseInt(wishlistId, 10) })
            .then(function (data) {
                var shareToken = data && data.shareToken;
                if (!shareToken) { showToast('Could not generate share link'); return; }
                var shareUrl = window.location.origin + '/pages/wishlist?share=' + shareToken;
                openShareModal(shareUrl);
            })
            .catch(function (err) { showToast(err && err.message ? err.message : 'Failed to share list'); });
    }

    function deleteWishlist(wishlistId) {
        showConfirmDialog({
            title: 'Delete list?',
            message: 'This cannot be undone. Items in this list will be unstarred.',
            confirmLabel: 'Delete',
            danger: true
        }).then(function (ok) {
            if (!ok) return;
            apiPost('api/wishlists/delete', { wishlistId: parseInt(wishlistId, 10) })
                .then(function () {
                    if (wlConfig.wishlistNotifPopup !== false) {
                        showToast('List deleted');
                    }
                    window.location.href = '/pages/wishlist';
                })
                .catch(function (err) {
                    console.error('[WL] delete error', err);
                    showToast(err && err.message ? err.message : 'Could not delete list');
                });
        });
    }

    // --- Create Modal ---
    var _modalEscHandler = null;

    function getModalEl() { return document.getElementById('wl-create-modal'); }
    function getOverlayEl() { return document.getElementById('wl-modal-overlay'); }

    function openCreateModal(productMeta) {
        modalMode = 'create';
        modalEditWishlistId = null;
        pickerProduct = productMeta;

        var modal = getModalEl();
        var overlay = getOverlayEl();
        if (!modal || !overlay) return;

        var titleEl = modal.querySelector('.wl-create-modal-header h3');
        var input = modal.querySelector('.wl-create-modal-input');
        var errEl = modal.querySelector('.wl-create-modal-error');
        var submitBtn = modal.querySelector('.wl-create-modal-submit');

        var descEl = modal.querySelector('.wl-create-modal-textarea');
        var descCount = modal.querySelector('[data-wl-desc-count]');

        if (titleEl) titleEl.textContent = 'Create new list';
        if (input) input.value = '';
        if (descEl) descEl.value = '';
        if (descCount) descCount.textContent = '0/150';
        if (errEl) { errEl.textContent = ''; errEl.setAttribute('hidden', ''); }
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Create'; }

        // A guest can still create a list — blocking them here would be worse —
        // but they should know it is device-bound before they name it, and be
        // offered the fix rather than only told the problem.
        var guestNote = modal.querySelector('[data-wl-create-guest]');
        if (guestNote) {
            if (IS_LOGGED_IN) {
                guestNote.setAttribute('hidden', '');
            } else {
                var signin = guestNote.querySelector('[data-wl-create-signin]');
                if (signin) {
                    var back = '/';
                    try { back = window.location.pathname + window.location.search; } catch (e) {}
                    signin.setAttribute('href',
                        '/customer_authentication/login?return_to=' + encodeURIComponent(back));
                }
                guestNote.removeAttribute('hidden');
            }
        }

        overlay.removeAttribute('hidden');
        modal.removeAttribute('hidden');

        if (input) setTimeout(function () { input.focus(); }, 50);

        _modalEscHandler = function (e) {
            if (e.key === 'Escape') closeCreateModal();
        };
        document.addEventListener('keydown', _modalEscHandler);
    }

    function closeCreateModal() {
        var modal = getModalEl();
        var overlay = getOverlayEl();
        if (modal) modal.setAttribute('hidden', '');
        if (overlay) overlay.setAttribute('hidden', '');
        if (_modalEscHandler) {
            document.removeEventListener('keydown', _modalEscHandler);
            _modalEscHandler = null;
        }
    }

    // Delegated click handler for modal buttons and picker create button
    document.addEventListener('click', function (e) {
        var action = e.target.closest('[data-action]');
        if (!action) return;

        var act = action.getAttribute('data-action');

        if (act === 'open-create-modal') {
            var savedProduct = pickerProduct;
            closeListPicker();
            pickerProduct = savedProduct;
            openCreateModal(pickerProduct);
            return;
        }

        if (act === 'close-create-modal') {
            closeCreateModal();
            return;
        }

        if (act === 'submit-create-modal') {
            handleCreateModalSubmit();
            return;
        }

        if (act === 'cancel-confirm') {
            closeConfirmDialog(false);
            return;
        }

        if (act === 'confirm-go') {
            closeConfirmDialog(true);
            return;
        }

        if (act === 'close-share-modal') {
            closeShareModal();
            return;
        }

        if (act === 'copy-share-url') {
            var modal = document.getElementById('wl-share-modal');
            var input = modal && modal.querySelector('[data-wl-share-url-input]');
            if (!input) return;
            copyToClipboard(input.value).then(function () {
                var btn = e.target.closest('[data-action="copy-share-url"]');
                if (btn) {
                    btn.classList.add('is-copied');
                    btn.textContent = 'Copied!';
                    setTimeout(function () {
                        btn.classList.remove('is-copied');
                        btn.textContent = 'Copy';
                    }, 1800);
                }
                if (input.select) input.select();
            }).catch(function () { showToast('Could not copy link'); });
            return;
        }
    });

    // Allow clicking overlay to close modal
    document.addEventListener('click', function (e) {
        var overlay = getOverlayEl();
        if (overlay && e.target === overlay) closeCreateModal();
        var confirmOverlay = document.getElementById('wl-confirm-overlay');
        if (confirmOverlay && e.target === confirmOverlay) closeConfirmDialog(false);
        var shareOverlay = document.getElementById('wl-share-overlay');
        if (shareOverlay && e.target === shareOverlay) closeShareModal();
    });

    // Allow Enter key to submit in modal input
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var modal = getModalEl();
        if (!modal || modal.hasAttribute('hidden')) return;
        if (e.target && e.target.classList.contains('wl-create-modal-textarea')) {
            var counter = document.querySelector('[data-wl-desc-count]');
            if (counter) counter.textContent = e.target.value.length + '/150';
        }
        if (e.target && e.target.classList.contains('wl-create-modal-input')) {
            handleCreateModalSubmit();
        }
    });

    // ESC closes confirm dialog
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var confirmModal = document.getElementById('wl-confirm-modal');
        if (confirmModal && !confirmModal.hasAttribute('hidden')) {
            closeConfirmDialog(false);
        }
    });

    function handleCreateModalSubmit() {
        var modal = getModalEl();
        if (!modal) return;

        var input = modal.querySelector('.wl-create-modal-input');
        var errEl = modal.querySelector('.wl-create-modal-error');
        var submitBtn = modal.querySelector('.wl-create-modal-submit');

        var descField = modal.querySelector('.wl-create-modal-textarea');
        var name = input ? input.value.trim() : '';
        var description = descField ? descField.value.trim() : '';

        if (!name || name.length < 1 || name.length > 80) {
            if (errEl) {
                errEl.textContent = name.length > 80
                    ? 'Name must be 80 characters or fewer'
                    : 'Please enter a list name';
                errEl.removeAttribute('hidden');
            }
            return;
        }

        if (errEl) { errEl.textContent = ''; errEl.setAttribute('hidden', ''); }
        if (submitBtn) submitBtn.disabled = true;

        if (modalMode === 'edit') {
            apiPost('api/wishlists/update', {
                wishlistId: parseInt(modalEditWishlistId, 10),
                name: name,
                description: description
            })
                .then(function () {
                    return loadWishlists();
                })
                .then(function () {
                    closeCreateModal();
                    if (wlConfig.wishlistNotifPopup !== false) {
                        showToast('List renamed');
                    }
                })
                .catch(function (e) {
                    console.error('[WL] update error', e);
                    if (submitBtn) submitBtn.disabled = false;
                    if (errEl) {
                        errEl.textContent = 'Failed to rename list — please try again';
                        errEl.removeAttribute('hidden');
                    }
                });
            return;
        }

        var savedProduct = pickerProduct;

        apiPost('api/wishlists/create', { name: name, description: description })
            .then(function (data) {
                var newWishlist = data.wishlist;
                state.wishlists.push(newWishlist);

                if (savedProduct && savedProduct.productId) {
                    return addToWishlist(
                        newWishlist.id,
                        savedProduct.productId,
                        savedProduct.variantId,
                        savedProduct.handle,
                        savedProduct.price,
                        savedProduct.sku
                    ).then(function () {
                        return loadWishlists();
                    }).then(function () {
                        closeCreateModal();
                        var thumbUrl = '';
                        var info = savedProduct.handle ? productCache[savedProduct.handle] : null;
                        if (info && info.featured_image) thumbUrl = info.featured_image;
                        if (wlConfig.wishlistNotifPopup !== false) {
                            if (IS_LOGGED_IN) {
                                showWishlistAddedToast(thumbUrl);
                            } else {
                                showToast(null, {
                                    thumb: thumbUrl,
                                    html: 'Item has been temporarily added to wishlist, please <a href="/account/login">login</a> to save it permanently'
                                });
                            }
                        }
                    });
                } else {
                    return loadWishlists().then(function () {
                        closeCreateModal();
                        if (wlConfig.wishlistNotifPopup !== false) {
                            showToast('Wishlist "' + name + '" created');
                        }
                    });
                }
            })
            .catch(function (e) {
                console.error('[WL] create error', e);
                if (submitBtn) submitBtn.disabled = false;
                if (e && e.code === 'GUEST_LIST_LIMIT') {
                    closeCreateModal();
                    showSignupGate('GUEST_LIST_LIMIT');
                    return;
                }
                if (e && e.code === 'GUEST_ITEM_LIMIT') {
                    closeCreateModal();
                    showSignupGate('GUEST_ITEM_LIMIT');
                    return;
                }
                if (errEl) {
                    errEl.textContent = 'Failed to create list — please try again';
                    errEl.removeAttribute('hidden');
                }
            });
    }

    window.addEventListener('popstate', function () {
        renderGroupsBlocks();
    });

    // --- Heart Button Creation ---
    var injectedSet = new WeakSet();

    function getProductMeta() {
        try {
            if (window.meta && window.meta.product) {
                var p = window.meta.product;
                return {
                    productId: 'gid://shopify/Product/' + p.id,
                    variantId: p.variants && p.variants[0] ? p.variants[0].id : '',
                    handle: p.handle || '',
                    price: p.variants && p.variants[0] ? p.variants[0].price / 100 : 0,
                    sku: p.variants && p.variants[0] ? p.variants[0].sku : '',
                };
            }
        } catch (e) {}
        return null;
    }

    var BUTTON_TYPES = ['heart-bordered', 'heart-noborder', 'text-bordered', 'text-noborder'];

    function applyButtonStyling(cfg) {
        var iconColor = (cfg && cfg.buttonIconColor) || '#616161';
        var bgColor = (cfg && cfg.buttonBgColor) || '#FFFFFF';
        var root = document.documentElement;
        root.style.setProperty('--wl-btn-icon', iconColor);
        root.style.setProperty('--wl-btn-bg', bgColor);

        // Card hearts sit beside the theme's basket button, whose size differs
        // per theme, so the fit is a merchant setting rather than a constant.
        var size = Number(cfg && cfg.buttonSize) || 32;
        size = Math.min(56, Math.max(24, size));
        root.style.setProperty('--wl-btn-size', size + 'px');

        var type = (cfg && cfg.buttonType) || 'heart-noborder';
        if (BUTTON_TYPES.indexOf(type) === -1) type = 'heart-noborder';
        document.body.setAttribute('data-wl-btn-type', type);
    }

    function buttonLabelBefore() {
        return langStr('wlBtnBefore', 'Add to Wishlist');
    }

    function buttonLabelAfter() {
        return langStr('wlBtnAfter', 'Added to Wishlist');
    }

    function renderHeartBtnContent(btn, active) {
        var type = (wlConfig && wlConfig.buttonType) || 'heart-noborder';
        var isText = type === 'text-bordered' || type === 'text-noborder';
        if (isText) {
            var label = active ? buttonLabelAfter() : buttonLabelBefore();
            btn.innerHTML = HEART_SVG + '<span class="wl-heart-btn-label">' + label + '</span>';
        } else {
            btn.innerHTML = HEART_SVG;
        }
    }

    function createHeartBtn(productId, variantId, handle, price, sku) {
        var btn = document.createElement('button');
        btn.className = 'wl-heart-btn';
        btn.setAttribute('data-product-id', String(productId));
        btn.setAttribute('data-variant-id', String(variantId || ''));
        btn.setAttribute('data-handle', String(handle || ''));
        btn.setAttribute('data-price', String(price || '0'));
        btn.setAttribute('data-sku', String(sku || ''));
        btn.setAttribute('aria-label', 'Add to Wishlist');
        btn.setAttribute('type', 'button');

        var active = isWishlisted(String(productId));
        renderHeartBtnContent(btn, active);

        if (active) {
            btn.classList.add('is-active');
        }

        btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var productMeta = {
                productId: btn.getAttribute('data-product-id'),
                variantId: btn.getAttribute('data-variant-id'),
                handle: btn.getAttribute('data-handle'),
                price: btn.getAttribute('data-price'),
                sku: btn.getAttribute('data-sku'),
            };

            // Cards are injected without price/SKU because those are the only
            // fields the theme does not render, and they are not needed until
            // this click. One cached lookup for the product actually clicked,
            // rather than one per card on every collection page.
            var needsDetail = (!productMeta.price || productMeta.price === '0' || !productMeta.sku);
            if (needsDetail && productMeta.handle) {
                fetchProductInfo(productMeta.handle).then(function (info) {
                    var v = info && info.variants && info.variants[0];
                    if (v) {
                        productMeta.price = String(v.price / 100);
                        productMeta.sku = String(v.sku || '');
                        btn.setAttribute('data-price', productMeta.price);
                        btn.setAttribute('data-sku', productMeta.sku);
                        if (!productMeta.productId && info.id) {
                            productMeta.productId = 'gid://shopify/Product/' + info.id;
                            btn.setAttribute('data-product-id', productMeta.productId);
                        }
                    }
                    openListPicker(productMeta, btn);
                });
                return;
            }

            openListPicker(productMeta, btn);
        });

        return btn;
    }

    function injectButtons() {
        var isProductPage = /\/products\/[^/]+/.test(window.location.pathname);

        if (isProductPage) {
            var productMeta = getProductMeta();
            if (!productMeta) return;

            // PDPs may have many cart/add forms (related-products quick-add etc).
            // Pick the largest VISIBLE basket button across all of them — that's
            // the main PDP CTA — then walk up to its form.
            var candidates = document.querySelectorAll(
                'form[action*="/cart/add"] [id^="ProductSubmitButton"],' +
                ' form[action*="/cart/add"] button[name="add"][type="submit"],' +
                ' form[action*="/cart/add"] .product-form__submit,' +
                ' form[action*="/cart/add"] button[name="add"],' +
                ' form[action*="/cart/add"] [type="submit"]'
            );
            var submitBtn = null;
            var maxArea = 0;
            candidates.forEach(function (b) {
                var r = b.getBoundingClientRect();
                var area = r.width * r.height;
                if (area > maxArea && r.width > 0 && r.height > 0) {
                    maxArea = area;
                    submitBtn = b;
                }
            });

            var form = submitBtn ? submitBtn.closest('form[action*="/cart/add"]') : document.querySelector('form[action*="/cart/add"]');
            if (form && !injectedSet.has(form)) {
                injectedSet.add(form);
                var btn = createHeartBtn(productMeta.productId, productMeta.variantId, productMeta.handle, productMeta.price, productMeta.sku);
                btn.classList.add('wl-heart-btn--pdp');

                if (submitBtn) {
                    var existingRow = submitBtn.parentNode.querySelector(':scope > .wl-pdp-cta-row');
                    if (!existingRow) {
                        var row = document.createElement('div');
                        row.className = 'wl-pdp-cta-row';
                        submitBtn.parentNode.insertBefore(row, submitBtn);
                        row.appendChild(submitBtn);
                        row.appendChild(btn);
                    } else {
                        existingRow.appendChild(btn);
                    }
                } else {
                    form.appendChild(btn);
                }
            }
        } else {
            var cards = document.querySelectorAll('.card-wrapper');
            var count = 0;
            var newlyInjectedHandles = [];
            cards.forEach(function (card) {
                try {
                    injectHeartIntoCard(card);
                } catch (err) {
                    // A single unexpected card shape must not take the page
                    // down with it.
                    console.error('[WL] heart injection failed for a card', err);
                }
            });

            function injectHeartIntoCard(card) {
                if (injectedSet.has(card)) return;
                var link = card.querySelector('a[href*="/products/"]');
                if (!link) return;

                var href = link.getAttribute('href') || '';
                var match = href.match(/\/products\/([^?#/]+)/);
                if (!match) return;

                injectedSet.add(card);
                count++;
                var handle = match[1];

                // The theme's .wishlist-engine slot already carries the ids
                // server-side, so read them here rather than fetching
                // /products/{handle}.js once per card. That fetch cost one
                // request per card (72 on a full collection page, ~8.5s of
                // request time) and, being staggered, did not settle until
                // seconds after load - which also meant an already-wishlisted
                // heart could not light up until its own fetch landed.
                var slot = card.querySelector('.wishlist-engine');
                var slotProductId = slot ? slot.getAttribute('data-product_id') : null;
                var slotVariantId = slot ? slot.getAttribute('data-variant_id') : null;
                var slotGid = slotProductId ? 'gid://shopify/Product/' + slotProductId : '';

                var btn = createHeartBtn(slotGid, slotVariantId || '', handle, '0');
                btn.classList.add('wl-heart-btn--collection');

                // The theme puts a .wishlist-engine div on every product card —
                // SE's slot, placed exactly where a heart belongs and present
                // on both card layouts (collection and paint), including
                // sold-out cards that have no basket button at all. It is empty
                // while SE's UI is dormant, and when SE is finally removed the
                // heart is already in the right place.
                var slot = card.querySelector('.wishlist-engine');
                var cartBtn = card.querySelector('.basket-button, .add-to-cart__submit, .cart-button');
                var target;

                if (slot) {
                    btn.classList.add('wl-heart-btn--inline');
                    slot.appendChild(btn);
                    target = slot;
                } else if (cartBtn && cartBtn.parentNode) {
                    btn.classList.add('wl-heart-btn--inline');
                    // Against the button's own parent: insertBefore throws
                    // NotFoundError when the reference node is not a direct
                    // child, and that throw once cost every card on the page
                    // its heart rather than just this one.
                    cartBtn.parentNode.insertBefore(btn, cartBtn);
                    target = cartBtn.parentNode;
                } else {
                    // Sold-out cards have neither the slot nor a basket button,
                    // so both anchors above miss them. Every card has a price
                    // though, and its row is where the controls belong — the
                    // floating treatment put the heart over the swatch, which
                    // on a paint page covers the product itself.
                    var priceEl = card.querySelector('.card_product_Price')
                        || card.querySelector('.card-product-price-div')
                        || card.querySelector('.card_sale_price');

                    if (priceEl && priceEl.parentNode) {
                        btn.classList.add('wl-heart-btn--inline');
                        // The Sold Out badge is float:right, so a heart in
                        // normal flow lands to the right of it and reads as an
                        // afterthought. Floating it too puts it left of the
                        // badge — price, heart, Sold Out — matching the
                        // price, heart, basket order on in-stock cards.
                        if (priceEl.parentNode.querySelector('.soldout_product_badge')) {
                            btn.classList.add('wl-heart-btn--float');
                        }
                        priceEl.parentNode.appendChild(btn);
                        target = priceEl.parentNode;
                    } else {
                        // Genuine last resort: float it over the image.
                        target = card.querySelector('.card__inner')
                            || card.querySelector('.card__media')
                            || card.querySelector('.card-media')
                            || card.querySelector('.media')
                            || card;
                        if (getComputedStyle(target).position === 'static') {
                            target.style.position = 'relative';
                        }
                        target.appendChild(btn);
                    }

                    // The theme renders filtered and paginated cards itself, so
                    // the slot can still arrive after we do; move into it if so.
                    relocateWhenSlotAppears(card, btn);
                }

                // Always tag the target with the handle so a later count pass
                // can fetch + render even if wlConfig hadn't loaded at inject time.
                target.setAttribute('data-wl-card-handle', handle);
                newlyInjectedHandles.push({ handle: handle, target: target });

                // Price and SKU are only read when the heart is clicked, so they are
                // resolved lazily there. Only a card whose slot gave us no ids still
                // needs a lookup, and that is now unstaggered because it is rare.
                if (!slotGid) {
                    fetchProductInfo(handle).then(function (product) {
                        if (!product || !product.variants || !product.variants[0]) return;
                        var gid = 'gid://shopify/Product/' + product.id;
                        btn.setAttribute('data-product-id', gid);
                        btn.setAttribute('data-variant-id', String(product.variants[0].id));
                        btn.setAttribute('data-price', String(product.variants[0].price / 100));
                        btn.setAttribute('data-handle', handle);
                        btn.setAttribute('data-sku', String(product.variants[0].sku || ''));
                        if (isWishlisted(gid)) {
                            btn.classList.add('is-active');
                            renderHeartBtnContent(btn, true);
                        }
                    });
                }
            }

            if (newlyInjectedHandles.length > 0) {
                ensurePublicCounts();
            }
        }
    }

    // Moves a floated heart into the card's own slot if that slot turns up
    // later. Two attempts, then it stays where it is — a card that still has
    // no slot after two seconds does not have one.
    function relocateWhenSlotAppears(card, btn) {
        var tries = 0;
        var timer = setInterval(function () {
            tries++;
            var slot = card.querySelector('.wishlist-engine');
            if (slot && btn.parentNode !== slot) {
                var previous = btn.parentNode;
                slot.appendChild(btn);
                btn.classList.add('wl-heart-btn--inline');
                // Only the floating variant set position:relative; leave any
                // other container exactly as found.
                if (previous && previous.style.position === 'relative') {
                    previous.style.position = '';
                }
                clearInterval(timer);
                return;
            }
            if (tries >= 2) clearInterval(timer);
        }, 900);
    }

    // Tracks handles we've already fetched a count for (to avoid duplicate requests).
    var _publicCountFetched = {};
    var _publicCountInFlight = false;

    function ensurePublicCounts() {
        if (!wlConfig || wlConfig.publicCount !== true) return;
        if (_publicCountInFlight) return;
        // Find all card targets that have a handle tagged but no badge yet.
        var pendingTargets = document.querySelectorAll('[data-wl-card-handle]');
        var items = [];
        pendingTargets.forEach(function (target) {
            var handle = target.getAttribute('data-wl-card-handle');
            if (!handle) return;
            if (_publicCountFetched[handle]) return;
            if (target.querySelector('.wl-public-count')) return;
            items.push({ handle: handle, target: target });
        });
        if (items.length === 0) return;
        _publicCountInFlight = true;
        var handles = items.map(function (i) { return i.handle; }).join(',');
        fetch(PROXY_BASE + '/api/wishlists/public-counts?handles=' + encodeURIComponent(handles), { credentials: 'include' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
                _publicCountInFlight = false;
                if (!data || !data.counts) return;
                items.forEach(function (item) {
                    _publicCountFetched[item.handle] = true;
                    var c = data.counts[item.handle] || 0;
                    if (c <= 0) return;
                    if (item.target.querySelector('.wl-public-count')) return;
                    var badge = document.createElement('span');
                    badge.className = 'wl-public-count';
                    badge.setAttribute('data-handle', item.handle);
                    badge.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span class="wl-public-count-num">' + c + '</span>';
                    item.target.appendChild(badge);
                });
            })
            .catch(function () { _publicCountInFlight = false; });
    }

    // --- Merge guest wishlists on login ---
    if (IS_LOGGED_IN && state.guestToken) {
        apiPost('api/wishlists/merge', {
            guestToken: state.guestToken,
            shopifyCustomerId: CUSTOMER_ID,
            customerEmail: CUSTOMER_EMAIL || undefined,
        })
            .then(function () {
                try { localStorage.removeItem('wl_guest_token'); } catch (e) {}
                state.guestToken = null;
            })
            .catch(function () {});
    }

    // --- MutationObserver for dynamic content ---
    var observer = new MutationObserver(function () { injectButtons(); });
    observer.observe(document.body, { childList: true, subtree: true });

    // --- Public API ---
    window.JadlamWishlist = {
        refresh: loadWishlists,
    };

    // --- Init (gated on widgetConfig.enabled) ---
    function disableWidget() {
        document.querySelectorAll(
            '.wl-heart-btn, .wl-header-heart, .wl-launcher, #wl-list-picker, #wl-modal-overlay, #wl-create-modal'
        ).forEach(function (el) {
            el.style.display = 'none';
        });
        document.querySelectorAll('[data-wl-groups]').forEach(function (el) {
            el.innerHTML = '';
        });
    }

    fetch(PROXY_BASE + '/api/settings/widget', { credentials: 'include' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
            var cfg = (data && data.widgetConfig) || {};
            wlConfig = cfg;
            if (cfg.enabled === false) {
                disableWidget();
                return;
            }
            injectFbPixel(cfg.fbPixelId);
            injectLaunchPoint(cfg.launchPoint);
            if (cfg.guestWishlist === false && !IS_LOGGED_IN) {
                disableWidget();
                return;
            }
            applyButtonStyling(cfg);
            enhanceHeaderHearts();
            var shareToken = getCurrentShareToken();
            if (shareToken) {
                loadSharedWishlist(shareToken).finally(function () {
                    loadWishlists();
                });
            } else {
                loadWishlists();
            }
            wireRecommendedCarousel();
            renderTrendingWidget();
            setTimeout(function () {
                injectButtons();
                ensurePublicCounts();
            }, 500);
        })
        .catch(function () {
            enhanceHeaderHearts();
            var shareToken = getCurrentShareToken();
            if (shareToken) {
                loadSharedWishlist(shareToken).finally(function () {
                    loadWishlists();
                });
            } else {
                loadWishlists();
            }
            wireRecommendedCarousel();
            setTimeout(injectButtons, 500);
        });
})();
